(function() {
    'use strict';

    angular.module('remitEventsApp', [
        'LocalStorageModule',
        'tmh.dynamicLocale',
        'pascalprecht.translate',
        'ui.bootstrap',
        'ngResource',
        'ui.router',
        'ngCookies',
        'ngAria',
        'ngCacheBuster',
        'ngFileUpload',
        'infinite-scroll',
        'angularMoment',
        'angularCSS',
        'ui.bootstrap.datetimepicker',
        'blockUI',
        'remitEventsFilters',
        'ngSanitize'
    ]);
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').service('DateUtils', function($filter) {
        this.convertLocaleDateToServer = function(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        };
        this.convertLocaleDateFromServer = function(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        };
        this.convertDateTimeFromServer = function(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($urlRouterProvider) {
        function changeLangugage($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale, language) {
            moment.locale(language);
            tmhDynamicLocale.set(language);

            $cookies.putObject('remit-lang', language);

            $translate.use(language).then(function() {
                $rootScope.$broadcast('languageChange', language);

                $state.transitionTo('main', _.extend({}, $state.params, { lang: language }), {
                    reload: true,
                    inherit: false,
                    notify: true
                });
            });
        }

        $urlRouterProvider.otherwise('/');
        $urlRouterProvider.when('/en', '/Remit/EN');
        $urlRouterProvider.when('/pl', '/Remit/PL');
        $urlRouterProvider.when('/Remit/PL', [
            '$cookies',
            '$rootScope',
            '$translate',
            '$state',
            'moment',
            'tmhDynamicLocale',
            function($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale) {
                changeLangugage($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale, 'pl');
            }
        ]);
        $urlRouterProvider.when('/Remit/EN', [
            '$cookies',
            '$rootScope',
            '$translate',
            '$state',
            'moment',
            'tmhDynamicLocale',
            function($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale) {
                changeLangugage($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale, 'en');
            }
        ]);
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').controller('TabsController', function($css, $scope, $state, $stateParams, Content) {
        var vm = this;
        var tabs = [
            {
                title: 'remitEventsApp.tabs.unavailability',
                availableCommodities: ['energy', 'gas'],
                disabled: false,
                active: false
            },
            {
                title: 'remitEventsApp.tabs.others',
                availableCommodities: 'others',
                commodity: 'others',
                disabled: false,
                active: false
            }
        ];
        var contractor = $stateParams.contractor ? $stateParams.contractor : 'all';

        vm.feedChanel = 'all';
        vm.tabs = [];

        vm.go = function(tab) {
            $state.go(tab.availableCommodities === 'others' ? 'event-others' : 'event', {
                commodity: $stateParams.commodity,
                contractor: tab.contractor ? tab.contractor : contractor
            });
        };

        vm.$onInit = function() {
            var isOthers = $state.current.data.otherEvents;
            var stateCommodity = isOthers ? 'others' : $stateParams.commodity;
            var commodityTabIndex = _.findIndex(tabs, function(tab) {
                var commodities = tab.availableCommodities;

                return _.isArray(commodities) ? commodities.indexOf(stateCommodity) !== -1 : commodities === stateCommodity;
            });

            if (commodityTabIndex !== -1) {
                tabs[0].commodity = stateCommodity;
            } else {
                commodityTabIndex = 0;
                $state.go('event', { commodity: 'energy', contractor: contractor });
            }

            vm.tabs = tabs;
            vm.commodityTabIndex = commodityTabIndex;
            vm.feedChanel = contractor !== 'production' ? contractor : 'all';

            $css.removeAll();
            $css.add(Content.getContractorCss());
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').controller('SiteController', function($state, $location) {
        var vm = this;

        vm.getTitle = function() {
            if (_.isObject($state.$current.data.pageHeader) && $state.$current.data.pageHeader.type === 'check') {
                var data = $state.$current.data.pageHeader;

                return $location.url().indexOf('/' + data.contractor) !== -1 ? data.then : data.else;
            }

            return $state.current.data.pageHeader || 'remitEventsApp.event.home.pageTitle';
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').service('PaginationService', function() {
        this.getPages = function(currentPage, totalElements, totalPages) {
            var pages = [];

            if (totalElements > 0) {
                var i = 1;

                if (totalPages < 8) {
                    for (i = 1; i <= totalPages; i++) {
                        pages.push(i);
                    }
                } else if (currentPage <= 5) {
                    for (i = 1; i <= 7; i++) {
                        pages.push(i);
                    }
                    if (i < totalPages) {
                        pages.push(0);
                    }
                    pages.push(totalPages);
                } else if (currentPage > 5 && currentPage + 3 < totalPages) {
                    pages.push(1);
                    pages.push(0);
                    for (i = currentPage - 3; i <= currentPage + 3; i++) {
                        pages.push(i);
                    }
                    if (i < totalPages) {
                        pages.push(0);
                    }
                    pages.push(totalPages);
                } else {
                    var j = totalPages - currentPage;
                    var k = 6 - j;

                    pages.push(1);
                    pages.push(0);

                    for (i = currentPage - k; i <= totalPages; i++) {
                        pages.push(i);
                    }
                }
            } else {
                pages.push(1);
            }

            return pages;
        };
    });
})();
;
(function() {
    'use strict';

    function PaginationController(PaginationService) {
        var vm = this;

        vm.currentPage = 1;
        vm.totalPages = 1;
        vm.lastPage = 1;
        vm.nextPage = 1;
        vm.prevPage = 0;
        vm.pages = [];

        vm.isActive = function(type) {
            var isActive = false;

            switch (type) {
                case 'first':
                    isActive = vm.lastPage > 1 && vm.currentPage > 1;
                    break;
                case 'prev':
                    isActive = vm.prevPage > 0 && vm.currentPage > 1;
                    break;
                case 'next':
                    isActive = vm.nextPage <= vm.lastPage && vm.currentPage !== vm.lastPage;
                    break;
                case 'last':
                    isActive = vm.lastPage > 1 && vm.currentPage < vm.totalPages;
                    break;
            }

            return isActive;
        };

        vm.goToPage = function(page, type) {
            var set = true;

            if (!_.isUndefined(type)) {
                set = vm.isActive(type);
            }

            if (set && vm.currentPage !== page) {
                vm.currentPage = page;
                vm.prevPage = Math.max(page - 1, 0);
                vm.nextPage = Math.min(page + 1, vm.lastPage + 1);

                vm.setPage({ value: page - 1 });
            }
        };

        vm.$onChanges = function() {
            vm.currentPage = vm.config.page + 1;

            vm.totalPages = Math.ceil(vm.config.totalElements / vm.config.size);
            vm.lastPage = vm.config.totalElements > 0 ? Math.ceil(vm.config.totalElements / vm.config.size) : 1;
            vm.nextPage = Math.max(2, Math.min(vm.currentPage + 1, vm.lastPage));
            vm.prevPage = Math.max(0, vm.currentPage - 1);

            vm.pages = PaginationService.getPages(vm.currentPage, vm.config.totalElements, vm.totalPages);
        };
    }

    angular.module('remitEventsApp').component('mriPagination', {
        templateUrl: 'scripts/components/pagination/pagination.html',
        controller: PaginationController,
        controllerAs: 'pagination',
        bindings: {
            config: '<',
            setPage: '&'
        }
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').controller('MenuController', function($location, $scope, $translate, ContractorFilter) {
        var vm = this;

        $scope.$on('contractorsSet', function(event, contractors) {
            vm.contractors = contractors;
        });

        vm.contractors = ContractorFilter.getGlobalContractors();

        vm.isActive = function(match, suffix) {
            var isActive = false;

            if (_.isArray(match)) {
                for (var i = 0; i < match.length; i++) {
                    var url = suffix ? match[i] + suffix : match[i];
                    isActive = isActive ? isActive : $location.url().indexOf(url) !== -1;
                }

                return isActive;
            }

            return $location.url().indexOf(match) !== -1;
        };

        vm.getPressOfficeLink = function(type) {
            var language = $translate.use();
            var link = '';

            switch (type) {
                case 'gas':
                    link =
                        language === 'pl'
                            ? 'pl/o-firmie/media/komunikaty-prasowe-kategorie/energetyka'
                            : 'en/about-the-company/media/press-releases-categories/power-generation';
                    break;
                case 'energy':
                    link =
                        language === 'pl'
                            ? 'pl/o-firmie/media/komunikaty-prasowe-kategorie/energetyka'
                            : 'en/about-the-company/media/press-releases-categories/power-generation';
                    break;
            }

            return 'http://www.orlen.pl/' + link;
        };
    });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .factory('Language', function($q, $translate, LANGUAGES) {
            return {
                getCurrent: function() {
                    var deferred = $q.defer();
                    var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

                    if (angular.isUndefined(language)) {
                        language = 'pl';
                    }

                    language = language.replace(/"/g, '');

                    deferred.resolve(language);
                    return deferred.promise;
                },
                getAll: function() {
                    var deferred = $q.defer();
                    deferred.resolve(LANGUAGES);
                    return deferred.promise;
                }
            };
        })

        /*
 Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 They are written in English to avoid character encoding issues (not a perfect solution)
 */
        .constant('LANGUAGES', [
            'en',
            'pl'
            //JHipster will add new languages here
        ]);
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('LanguageController', function($rootScope, $scope, $translate, Language, tmhDynamicLocale, $window, moment) {
            $scope.changeLanguage = function(languageKey) {
                $translate.use(languageKey);
                tmhDynamicLocale.set(languageKey);
                moment.locale(languageKey);
                if (languageKey == 'pl') {
                    $scope.altLanguage = { key: 'en', label: 'English' };
                } else {
                    $scope.altLanguage = { key: 'pl', label: 'Polski' };
                }
                $rootScope.$broadcast('languageChange');
            };

            $scope.altLanguage = { key: 'en', label: 'English' };

            Language.getAll().then(function(languages) {
                $scope.languages = languages;
            });
        })
        .filter('findLanguageFromKey', function() {
            return function(lang) {
                return {
                    ca: 'Català',
                    da: 'Dansk',
                    de: 'Deutsch',
                    en: 'English',
                    es: 'Español',
                    fr: 'Français',
                    hu: 'Magyar',
                    it: 'Italiano',
                    ja: '日本語',
                    ko: '한국어',
                    nl: 'Nederlands',
                    pl: 'Polski',
                    'pt-br': 'Português (Brasil)',
                    'pt-pt': 'Português',
                    ro: 'Română',
                    ru: 'Русский',
                    sv: 'Svenska',
                    tr: 'Türkçe',
                    'zh-cn': '中文（简体）',
                    'zh-tw': '繁體中文'
                }[lang];
            };
        });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').service('HelpersService', function($document, $sce, $rootScope) {
        var currentSetPrevFiltersState = null;

        /* jshint ignore:start */
        this.applyScope = function(scope) {
            // eslint-disable-next-line angular/no-private-call
            if (!scope.$$phase && scope.$root && !scope.$root.$$phase) {
                scope.$apply();
            }
        };
        /* jshint ignore:end */

        this.setPreviusFilters = function(stateName, data) {
            $rootScope.filters = {};
            $rootScope.filters[stateName] = data;

            currentSetPrevFiltersState = 2;
        };

        this.loadPreviusFilters = function(stateName) {
            return $rootScope.filters ? $rootScope.filters[stateName] : {};
        };

        this.clearPrevData = function() {
            if (currentSetPrevFiltersState === 0) {
                currentSetPrevFiltersState = null;
                $rootScope.filters = {};
            }

            if (currentSetPrevFiltersState) {
                currentSetPrevFiltersState--;
            }
        };

        this.getPaginationConfig = function() {
            return {
                totalElements: 0,
                page: 0,
                size: 20
            };
        };

        this.findElement = function(element) {
            var domElement = angular.element($document[0].querySelector(element));

            var that = {
                element: domElement[0],
                width: function(value) {
                    if (value) {
                        domElement[0].style.width = _.isNumber(value) ? value + 'px' : value;

                        return that;
                    }

                    return domElement[0] ? domElement[0].clientWidth : 0;
                },
                height: function(value) {
                    if (value) {
                        domElement[0].style.height = _.isNumber(value) ? value + 'px' : value;

                        return that;
                    }

                    return domElement[0] ? domElement[0].clientHeight : 0;
                },
                position: function() {
                    var leftPosition = domElement[0].offsetWidth - parseInt(domElement[0].style.width);

                    return {
                        left: leftPosition
                    };
                },
                scrollLeft: function(value) {
                    if (domElement[0]) {
                        domElement[0].scrollLeft = value;
                    }

                    return that;
                },
                css: function(value) {
                    domElement.css(value);

                    return that;
                },
                addClass: function(value) {
                    domElement.addClass(value);

                    return that;
                },
                removeClass: function(value) {
                    domElement.removeClass(value);

                    return that;
                },
                removeAttr: function(value) {
                    domElement.removeAttr(value);

                    return that;
                }
            };

            return that;
        };

        this.normalize = function(str) {
            str = str || '';
            return str
                .toLowerCase()
                .replace(/\\s/g, '')
                .replace(/[ą]/g, 'azzz')
                .replace(/[ć]/g, 'czzz')
                .replace(/[ę]/g, 'ezzz')
                .replace(/[ł]/g, 'lzzz')
                .replace(/[ń]/g, 'nzzz')
                .replace(/[ó]/g, 'ozzz')
                .replace(/[ś]/g, 'szzz')
                .replace(/[żź]/g, 'zzz')
                .replace(/\\W/g, '');
        };

        this.objectIsEmpty = function(obj) {
            if (!obj) return true;

            if (obj.length > 0) return false;
            if (obj.length === 0) return true;

            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }

            return true;
        };

        this.returnAsTrustedHTML = function(value) {
            return $sce.trustAsHtml(value);
        };

        this.copyObjectArray = function(objArr) {
            if (objArr) {
                return angular.fromJson(angular.toJson(objArr));
            }

            return {};
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').controller('HeaderController', function($cookies, $rootScope, $translate, moment, tmhDynamicLocale) {
        var vm = this;

        function checkActiveLanguage(language) {
            return language === $translate.use();
        }

        vm.changeLanguage = function(language) {
            if (!checkActiveLanguage(language)) {
                $translate.use(language).then(function() {
                    $translate.refresh().then(function() {
                        $rootScope.$broadcast('languageChange', language);
                    });
                });

                moment.locale(language);
                tmhDynamicLocale.set(language);
                $cookies.putObject('remit-lang', language);
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').controller('FooterController', function($translate) {
        var vm = this;

        vm.getLink = function(type) {
            var language = $translate.use();
            var link = '';

            switch (type) {
                case 'privacyPolicy':
                    link = language === 'pl' ? 'PL/PolitykaPrywatnosci/Strony/default.aspx' : 'EN/PrivacyPolicy/Pages/default.aspx';
                    break;
                case 'legalReservations':
                    link = language === 'pl' ? 'PL/ZastrzezeniaPrawne/Strony/default.aspx' : 'EN/LegalDisclaimer/Pages/default.aspx';
                    break;
                default:
                    link = language === 'pl' ? 'PL/' : 'EN/';
            }

            return 'http://www.orlen.pl/' + link;
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsFilters', []).filter('dayspan', function(EventFilter) {
        return function(events) {
            var currDay = null;
            var currDayCount = 0;
            var firstEventWithCurrDate = null;

            _.each(events, function(event) {
                var day = moment(event.publicationDate).startOf('day');

                if (day.isSame(currDay)) {
                    if (EventFilter.shouldBeShown(event)) {
                        if (firstEventWithCurrDate) {
                            currDayCount++;
                            event.showDate = false;
                        } else {
                            currDayCount = 1;
                            firstEventWithCurrDate = event;
                            event.showDate = true;
                        }
                    } else {
                        event.showDate = true;
                    }
                } else {
                    currDay = day;
                    event.showDate = true;
                    if (firstEventWithCurrDate) {
                        firstEventWithCurrDate.sameDayCount = currDayCount;
                    }

                    if (EventFilter.shouldBeShown(event)) {
                        currDayCount = 1;
                        firstEventWithCurrDate = event;
                    } else {
                        firstEventWithCurrDate = null;
                    }
                }

                if (firstEventWithCurrDate) {
                    firstEventWithCurrDate.sameDayCount = currDayCount;
                }
            });

            return events;
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Unavailability', function($resource) {
        return $resource(
            'api/unavailabilities',
            {},
            {
                query: { method: 'GET', isArray: false }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('ProductionUnit', function($resource) {
        return $resource(
            'api/productionUnits/:id',
            {},
            {
                query: { method: 'GET', isArray: true },
                get: {
                    method: 'GET',
                    transformResponse: function(data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                update: { method: 'PUT' }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Graph', function($resource, HelpersService) {
        return {
            decorateWithStyles: function(powerplants) {
                var that = this;
                _.each(powerplants, function(powerplant) {
                    that.decorateUnavailabilitiesWithStyles(powerplant.unavailabilities);
                    _.each(powerplant.blocks, function(block) {
                        that.decorateUnavailabilitiesWithStyles(block.unavailabilities);
                    });
                });
            },
            decorateUnavailabilitiesWithStyles: function(unavailabilities) {
                _.each(unavailabilities, function(unavailability) {
                    var notPlannedHeight = unavailability.notPlannedUnavailability / unavailability.installedCapacity;
                    var plannedHeight = unavailability.plannedUnavailability / unavailability.installedCapacity;
                    var sumHeight = notPlannedHeight + plannedHeight;
                    if (sumHeight > 1) {
                        notPlannedHeight = notPlannedHeight / sumHeight;
                        plannedHeight = plannedHeight / sumHeight;
                    }
                    unavailability.plannedStyle = {
                        'background-color': '#092D74',
                        width: '100%',
                        height: plannedHeight * 59 + 'px'
                    };
                    unavailability.notPlannedStyle = {
                        'background-color': '#E60007',
                        width: '100%',
                        height: notPlannedHeight * 59 + 'px'
                    };
                });
            },

            decorateWithVisibility: function(powerplants) {
                var groupId = 0;
                var showHeader = true;
                _.each(powerplants, function(powerplant) {
                    powerplant.visible = true;
                    powerplant.showHeader = showHeader;
                    showHeader = false;
                    groupId++;
                    powerplant.groupId = groupId;
                    _.each(powerplant.blocks, function(block) {
                        block.visible = false;
                        block.groupId = groupId;
                    });
                });
            },

            toggleBlocks: function(powerplants, groupId) {
                var showHeader = true;
                _.each(powerplants, function(powerplant) {
                    powerplant.showHeader = showHeader;
                    if (powerplant.groupId === groupId) {
                        var powerplantVisible = powerplant.visible;
                        powerplant.visible = !powerplant.visible;
                        _.each(powerplant.blocks, function(block) {
                            block.visible = powerplantVisible;
                        });
                    }
                    showHeader = !powerplant.visible;
                });
            },

            getWeeks: function(year) {
                var tmpDate = moment({
                    year: year,
                    month: 0,
                    day: 1
                }).startOf('week');
                var weeks = [];
                while (
                    tmpDate.isBefore(
                        moment({
                            year: year + 1
                        })
                    )
                ) {
                    var weekId = tmpDate.get('week');
                    var dayFrom = tmpDate.format('DD');
                    var weekEnd = tmpDate
                        .clone()
                        .add(1, 'weeks')
                        .add(-1, 'day');
                    var dayTo = weekEnd.format('DD');
                    var currentWeek = moment().isBetween(tmpDate, weekEnd);

                    weeks.push({
                        id: weekId,
                        currentWeek: currentWeek,
                        label: 'remitEventsApp.graph.granulation.weeks.' + tmpDate.format('MM') + weekEnd.format('MM'),
                        labelParams: {
                            id: weekId,
                            from: dayFrom,
                            to: dayTo
                        },
                        date: tmpDate.clone()
                    });

                    tmpDate.add(1, 'weeks');
                }

                return weeks;
            },

            getDecoratedTimestamps: function(timestamps, granulation) {
                if (granulation == 'YEAR') {
                    _.each(timestamps, function(timestamp) {
                        timestamp.label = 'remitEventsApp.graph.granulation.months.short.' + timestamp.label;
                    });
                }

                return timestamps;
            },
            setControlsScroll: function() {
                var $rigthScrollControl = HelpersService.findElement('.scroll-bar.right');
                var $leftScrollControl = HelpersService.findElement('.scroll-bar.left');
                var $tableNames = HelpersService.findElement('.table-with-names');

                if ($tableNames.element) {
                    $rigthScrollControl.height($tableNames.height() - 80);
                    $leftScrollControl.height($tableNames.height() - 80);
                }
            },
            setTablePosition: function() {
                var $tableDataScroll = HelpersService.findElement('.table-data-scroll');

                if (!$tableDataScroll.element) {
                    return;
                }

                var widthTable = $tableDataScroll.width() + HelpersService.findElement('.side-graph.left').width() + 30;
                var leftPosition = HelpersService.findElement('.powerplant-row').width() + 18;
                var widthContainer = HelpersService.findElement('.energy-table').width();
                var $rigthScrollControl = HelpersService.findElement('.scroll-bar.right');
                var $leftScrollControl = HelpersService.findElement('.scroll-bar.left');

                HelpersService.findElement('.side-graph.right').scrollLeft(widthTable - widthContainer);

                $leftScrollControl.css({
                    left: leftPosition + 'px'
                });

                if (widthTable < widthContainer) {
                    $rigthScrollControl
                        .css({
                            left:
                                HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').position().left +
                                HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').width() +
                                HelpersService.findElement('.side-graph.left').width() +
                                15
                        })
                        .addClass('disabled');
                    $leftScrollControl.addClass('disabled');
                } else {
                    $rigthScrollControl
                        .removeAttr('style')
                        .css({
                            right: '20px'
                        })
                        .removeClass('disabled');
                    $leftScrollControl.removeClass('disabled');
                }

                this.setControlsScroll();
            },
            getLastEventYear: function() {
                return $resource(
                    'api/events/lastEventYear',
                    {},
                    {
                        query: {
                            method: 'GET',
                            isArray: false
                        }
                    }
                );
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Event', function($resource, DateUtils) {
        return $resource(
            'api/events/:mode/:id',
            {},
            {
                query: { method: 'GET', isArray: false },
                get: {
                    method: 'GET'
                },
                update: {
                    method: 'PUT',
                    transformRequest: function(data) {
                        data.publicationDate = DateUtils.convertLocaleDateToServer(data.publicationDate);
                        data.eventStart = DateUtils.convertLocaleDateFromServer(data.eventStart);
                        data.eventStop = DateUtils.convertLocaleDateFromServer(data.eventStop);
                        return angular.toJson(data);
                    }
                },
                save: {
                    method: 'POST',
                    transformRequest: function(data) {
                        data.publicationDate = DateUtils.convertLocaleDateToServer(data.publicationDate);
                        data.eventStart = DateUtils.convertLocaleDateFromServer(data.eventStart);
                        data.eventStop = DateUtils.convertLocaleDateFromServer(data.eventStop);
                        return angular.toJson(data);
                    }
                }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('EventFilter', function($stateParams, $resource, Event, ContractorFilter, Content) {
        return {
            getSortOptions: function(type) {
                return _.filter(
                    [
                        {
                            id: 1,
                            sort: {
                                sortBy: 'publicationDate',
                                order: 'desc'
                            },
                            type: 'other',
                            label: 'remitEventsApp.event.sortOptions.publicationDateDesc'
                        },
                        {
                            id: 2,
                            sort: {
                                sortBy: 'publicationDate',
                                order: 'asc'
                            },
                            type: 'other',
                            label: 'remitEventsApp.event.sortOptions.publicationDateAsc'
                        },
                        {
                            id: 3,
                            sort: {
                                sortBy: 'eventStart',
                                order: 'desc'
                            },
                            label: 'remitEventsApp.event.sortOptions.eventStartDesc'
                        },
                        {
                            id: 4,
                            sort: {
                                sortBy: 'eventStart',
                                order: 'asc'
                            },
                            label: 'remitEventsApp.event.sortOptions.eventStartAsc'
                        }
                    ],
                    function(value) {
                        return (!value.type && !type) || value.type === type || !type;
                    }
                );
            },
            loadAll: function(mode, paginationConfig, eventFilter, sort, callback) {
                var that = this;
                ContractorFilter.promiseConfig().then(function(result) {
                    var config = result;
                    var contractorEic = 'all';
                    var foundContractor = _.find(config, function(contractor) {
                        return contractor.shortName === $stateParams.contractor;
                    });

                    if (!_.isEmpty(foundContractor)) {
                        contractorEic = foundContractor.eicCode;
                    }

                    that._loadEvents(mode, paginationConfig, eventFilter, contractorEic, sort, callback);
                });
            },
            _loadEvents: function(mode, paginationConfig, eventFilter, contractorEic, sort, callback) {
                var queryParams = { mode: mode };
                var sortOption = {
                    sortBy: 'publicationDate',
                    order: 'desc'
                };

                if (sort) {
                    var data = _.find(this.getSortOptions(), function(value) {
                        return value.id === sort.id;
                    });

                    if (data) {
                        sortOption = data.sort;
                    }
                }

                if (contractorEic !== 'all') {
                    eventFilter.contractor = contractorEic;
                } else {
                    delete eventFilter.contractor;
                }

                if (eventFilter.dateFrom) {
                    eventFilter.dateFrom = moment.isMoment(eventFilter.dateFrom)
                        ? eventFilter.dateFrom.format('YYYY/MM/DD HH:mm:ss')
                        : eventFilter.dateFrom;
                }

                if (eventFilter.dateTo) {
                    eventFilter.dateTo = moment.isMoment(eventFilter.dateTo)
                        ? eventFilter.dateTo.endOf('day').format('YYYY/MM/DD HH:mm:ss')
                        : eventFilter.dateTo;
                }

                if (paginationConfig) {
                    queryParams = _.extend(queryParams, {
                        page: paginationConfig.page,
                        size: paginationConfig.size,
                        sortBy: sortOption.sortBy,
                        order: sortOption.order
                    });
                }

                queryParams = _.extend(queryParams, eventFilter);

                Event.query(queryParams, function(result) {
                    callback(result);
                });
            },
            filterRange: function(event, dateFrom, dateTo) {
                if (event.publicationDate) {
                    var inDateRange = true;
                    var publicationDate = moment(event.publicationDate);
                    if (dateFrom) {
                        inDateRange = inDateRange && publicationDate.isSameOrAfter(dateFrom);
                    }
                    if (dateTo) {
                        inDateRange = inDateRange && publicationDate.isSameOrBefore(dateTo);
                    }
                    return inDateRange || this.eventDatesInRange(event, dateFrom, dateTo);
                } else {
                    console.error('Event with id ' + event.id + " doesn't have publicationDate");
                    return false;
                }
            },
            eventDatesInRange: function(event, dateFrom, dateTo) {
                var inDateRange = true;
                if (event.eventStart && dateTo) {
                    var eventStart = moment(event.eventStart);
                    inDateRange = eventStart.isBefore(dateTo);
                }
                if (event.eventStop && dateFrom) {
                    var eventStop = moment(event.eventStop);
                    inDateRange = inDateRange && eventStop.isAfter(dateFrom);
                }

                return inDateRange;
            },
            getSelectedcontractors: function(contractors, stateContractor) {
                return _.map(
                    _.filter(contractors, function(contractor) {
                        return contractor.shortName === stateContractor;
                    }),
                    function(contractor) {
                        return contractor.id;
                    }
                );
            },
            getSelectedEventTypes: function(eventTypes) {
                var selectedEventTypes = _.filter(eventTypes, function(eventType) {
                    return eventType.selected;
                });
                var selectedEventTypeIds = _.map(selectedEventTypes, function(eventType) {
                    return eventType.value;
                });

                return selectedEventTypeIds;
            },
            getAssentNames: function(assentNames) {
                var selectedAssentNames = _.filter(assentNames, function(assentName) {
                    return assentName.selected;
                });

                return _.map(selectedAssentNames, function(assentName) {
                    return assentName.name;
                });
            },
            filterContractors: function(event, eventFilter) {
                return _.isEmpty(eventFilter.contractorIds) || _.contains(eventFilter.contractorIds, event.marketParticipantCode);
            },
            filterEventTypes: function(event, eventFilter) {
                return _.isEmpty(eventFilter.eventTypes) || _.contains(eventFilter.eventTypes, event.eventType);
            },
            getEventFilter: function(dateFrom, dateTo, contractors, eventTypes, dictionaries, stateContractor) {
                return {
                    dateFrom: dateFrom ? moment(dateFrom, 'DD/MM/YYYY').startOf('day') : null,
                    dateTo: dateTo ? moment(dateTo, 'DD/MM/YYYY').endOf('day') : null,
                    contractorIds: this.getSelectedcontractors(contractors, stateContractor),
                    eventTypes: this.getSelectedEventTypes(eventTypes),
                    assentNames: this.getAssentNames(dictionaries.assentNames)
                };
            },
            translateRemarks: function(events, language) {
                _.each(events, function(event) {
                    event.remarksTranslated = language === 'pl' ? event.remarks : event.remarksEN;
                });
                return events;
            },
            translateReasons: function(events, language) {
                _.each(events, function(event) {
                    event.unavailabilityReasonTranslated = language === 'pl' ? event.unavailabilityReason : event.unavailabilityReasonEN;
                });

                return events;
            },
            getEventTypes: function() {
                return [
                    { value: 'PLANNED', selected: false, label: 'remitEventsApp.MriEventType.PLANNED' },
                    { value: 'NOT_PLANNED', selected: false, label: 'remitEventsApp.MriEventType.NOT_PLANNED' }
                ];
            },
            shouldBeShown: function(event) {
                return event.currentVersion;
            },
            contractorsShown: function(contractors) {
                return $stateParams.contractor === 'all' || contractors.length > 1;
            },
            dateRangeChanged: function(lastDateRange, dateFrom, dateTo) {
                return (
                    (_.isEmpty(lastDateRange.dateFrom) && _.isEmpty(lastDateRange.dateTo)) ||
                    dateFrom.isBefore(lastDateRange.dateFrom) ||
                    dateTo.isAfter(lastDateRange.dateTo)
                );
            },
            excelLink: function(eventFilter) {
                var dateFrom = moment(eventFilter.dateFrom, 'YYYY/MM/DD').format('YYYY/MM/DD');
                var dateTo = moment(eventFilter.dateTo, 'YYYY/MM/DD')
                    .clone()
                    .add(1, 'day')
                    .format('YYYY/MM/DD');
                var commodity = Content.getCommodityEnum($stateParams.commodity);
                var link = 'xlsx/' + commodity + '?dateFrom=' + dateFrom + '&dateTo=' + dateTo;

                if (!_.isEmpty(eventFilter.contractorIds)) {
                    link += '&contractors=' + eventFilter.contractorIds.join();
                } else if (['all', 'production', 'information'].indexOf($stateParams.contractor) === -1) {
                    link += '&contractors=' + $stateParams.contractor;
                }
                return link;
            },
            markContractorsSelected: function(contractors, selectedIds) {
                _.each(contractors, function(contractor) {
                    if (_.contains(selectedIds, contractor.id)) {
                        contractor.selected = true;
                    }
                });
            },
            markEventTypesSelected: function(eventTypes, eventTypesSelected) {
                _.each(eventTypes, function(eventType) {
                    if (_.contains(eventTypesSelected, eventType.value)) {
                        eventType.selected = true;
                    }
                });
            },
            markAssentNamesSelected: function(assentNames, selected) {
                _.each(assentNames, function(assentName) {
                    if (_.contains(selected, assentName.name)) {
                        assentName.selected = true;
                    }
                });
            },
            getAssentNamesData: function() {
                return $resource(
                    'api/dictionaries/assentNames',
                    {},
                    {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    }
                );
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('EventDetails', function($resource) {
        return $resource(
            'api/events/:messageId',
            {},
            {
                query: { method: 'GET', isArray: true }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Contractor', function($resource) {
        return $resource(
            'api/contractors',
            {},
            {
                query: { method: 'GET', isArray: true }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('ContractorFilter', function(Contractor, ContractorConfig, $rootScope) {
        var globalContractors = [];
        var globalContractorsConfig = [];

        return {
            getContractors: function() {
                if (_.isEmpty(globalContractors)) {
                    var contractorsForFilter = [];
                    var that = this;

                    this.promiseConfig().then(function(config) {
                        that._promiseContractors().then(function(contractors) {
                            _.each(contractors, function(contractor) {
                                var eic = contractor;
                                var contractorInConfig = that._getContractorFromConfig(config, eic);
                                if (!_.isEmpty(contractorInConfig)) {
                                    var contractorForFilter = {
                                        id: eic,
                                        label: contractorInConfig.name,
                                        selected: false,
                                        shortName: contractorInConfig.shortName
                                    };
                                    contractorsForFilter.push(contractorForFilter);
                                }
                            });
                            globalContractors = contractorsForFilter;
                            $rootScope.$broadcast('contractorsSet', globalContractors);
                        });
                        globalContractorsConfig = config;
                        $rootScope.$broadcast('contractorsConfigSet', globalContractorsConfig);
                    });
                }

                return globalContractors;
            },
            getGlobalContractors: function() {
                if (_.isEmpty(globalContractorsConfig)) {
                    return this.getContractors();
                }

                return globalContractors;
            },
            getContractorsConfig: function() {
                if (_.isEmpty(globalContractorsConfig)) {
                    this.promiseConfig().then(function(config) {
                        globalContractorsConfig = config;
                    });
                }

                return globalContractorsConfig;
            },
            _getContractorFromConfig: function(config, eic) {
                var foundContractor = _.find(config, function(contractor) {
                    return contractor.eicCode === eic;
                });

                return foundContractor;
            },
            _promiseContractors: function() {
                return Contractor.query({}).$promise;
            },
            promiseConfig: function() {
                return ContractorConfig.query({}).$promise;
            },
            filterByShortName: function(contractors, shortName) {
                if (shortName === 'all') {
                    return contractors;
                }
                return _.filter(contractors, function(contractor) {
                    return contractor.shortName === shortName;
                });
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('ContractorConfig', function($resource) {
        return $resource(
            'api/contractors/config',
            {},
            {
                query: { method: 'GET', isArray: true }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').service('DictionariesService', function() {
        this.generateDictionary = function(values, nlsCode, idAtIndex) {
            var dictionaries = [];

            for (var i = 0; i < values.length; i++) {
                dictionaries.push({
                    id: idAtIndex ? i : values[i],
                    label: nlsCode ? nlsCode + '.' + values[i] : values[i]
                });
            }

            return dictionaries;
        };

        this.getGranulations = function() {
            return this.generateDictionary(['DAY', 'WEEK', 'MONTH', 'YEAR'], 'remitEventsApp.graph.granulation');
        };

        this.getYears = function() {
            var years = [];

            for (var year = 2011; year <= 2019; year++) {
                years.push(year);
            }

            return this.generateDictionary(years);
        };

        this.getMonths = function() {
            return this.generateDictionary(
                ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                'remitEventsApp.graph.granulation.months',
                true
            );
        };
    });
})();
;
/*globals define, jQuery, module, require */
/*jslint vars:true */

/**
 * @license angular-bootstrap-datetimepicker  version: 0.4.0
 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
 * License: MIT
 *
 * @author        Dale "Ducky" Lotts
 * @since        2013-Jul-8
 */

(function (factory) {
  'use strict';
  /* istanbul ignore if */
  if (typeof define === 'function' && /* istanbul ignore next */ define.amd) {
    define(['angular', 'moment'], factory); // AMD
    /* istanbul ignore next */
  } else if (typeof exports === 'object') {
    module.exports = factory(require('angular'), require('moment')); // CommonJS
  } else {
    factory(window.angular, window.moment); // Browser global
  }
}(function (angular, moment) {
  'use strict';
  angular.module('ui.bootstrap.datetimepicker', [])
    .service('dateTimePickerConfig', DateTimePickerConfigProvider)
    .service('dateTimePickerValidator', DateTimePickerValidatorService)
    .directive('datetimepicker', DatetimepickerDirective);

  DatetimepickerDirective.$inject = ['dateTimePickerConfig', 'dateTimePickerValidator'];

  function DatetimepickerDirective(defaultConfig, configurationValidator) {

    var directiveDefinition = {
      bindToController: false,
      controller: DirectiveController,
      controllerAs: 'dateTimePickerController',
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        beforeRender: '&',
        onSetTime: '&'
      },
      templateUrl: 'templates/datetimepicker.html'
    };

    DirectiveController.$inject = ['$scope', '$element', '$attrs'];

    function DirectiveController($scope, $element, $attrs) {
      // Configuration
      var ngModelController = $element.controller('ngModel');

      var configuration = createConfiguration();
      $scope.screenReader = configuration.screenReader;

      // Behavior
      $scope.changeView = changeView;
      ngModelController.$render = $render;

      if (configuration.configureOn) {
        $scope.$on(configuration.configureOn, function () {
          configuration = createConfiguration();
          $scope.screenReader = configuration.screenReader;
          ngModelController.$render();
        });
      }

      if (configuration.renderOn) {
        $scope.$on(configuration.renderOn, ngModelController.$render);
      }

      // Implementation

      var viewToModelFactory = {
        year: yearModelFactory,

        month: monthModelFactory,

        day: dayModelFactory,

        hour: hourModelFactory,

        minute: minuteModelFactory,

        setTime: setTime
      };

      function changeView(viewName, dateObject, event) {
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }

        if (viewName && (dateObject.utcDateValue > -Infinity) && dateObject.selectable && viewToModelFactory[viewName]) {
          var result = viewToModelFactory[viewName](dateObject.utcDateValue);

          var weekDates = [];
          if (result.weeks) {
            for (var i = 0; i < result.weeks.length; i += 1) {
              var week = result.weeks[i];
              for (var j = 0; j < week.dates.length; j += 1) {
                var weekDate = week.dates[j];
                weekDates.push(weekDate);
              }
            }
          }

          $scope.beforeRender({
            $view: result.currentView,
            $dates: result.dates || weekDates,
            $leftDate: result.leftDate,
            $upDate: result.previousViewDate,
            $rightDate: result.rightDate
          });

          $scope.data = result;
        }
      }

      function yearModelFactory(milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('year');
        // View starts one year before the decade starts and ends one year after the decade ends
        // i.e. passing in a date of 1/1/2013 will give a range of 2009 to 2020
        // Truncate the last digit from the current year and subtract 1 to get the start of the decade
        var startDecade = (parseInt(selectedDate.year() / 10, 10) * 10);
        var startDate = moment.utc(startOfDecade(milliseconds)).subtract(1, 'year').startOf('year');

        var activeYear = formatValue(ngModelController.$modelValue, 'YYYY');

        var result = {
          'currentView': 'year',
          'nextView': configuration.minView === 'year' ? 'setTime' : 'month',
          'previousViewDate': new DateObject({
            utcDateValue: null,
            display: startDecade + '-' + (startDecade + 9)
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(9, 'year').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(11, 'year').valueOf()}),
          'dates': []
        };

        for (var i = 0; i < 12; i += 1) {
          var yearMoment = moment.utc(startDate).add(i, 'years');
          var dateValue = {
            'utcDateValue': yearMoment.valueOf(),
            'display': yearMoment.format('YYYY'),
            'past': yearMoment.year() < startDecade,
            'future': yearMoment.year() > startDecade + 9,
            'active': yearMoment.format('YYYY') === activeYear
          };

          result.dates.push(new DateObject(dateValue));
        }

        return result;
      }

      function monthModelFactory(milliseconds) {

        var startDate = moment.utc(milliseconds).startOf('year');
        var previousViewDate = startOfDecade(milliseconds);
        var activeDate = formatValue(ngModelController.$modelValue, 'YYYY-MMM');

        var result = {
          'previousView': 'year',
          'currentView': 'month',
          'nextView': configuration.minView === 'month' ? 'setTime' : 'day',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: startDate.format('YYYY')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(1, 'year').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(1, 'year').valueOf()}),
          'dates': []
        };

        for (var i = 0; i < 12; i += 1) {
          var monthMoment = moment.utc(startDate).add(i, 'months');
          var dateValue = {
            'utcDateValue': monthMoment.valueOf(),
            'display': monthMoment.format('MMM'),
            'active': monthMoment.format('YYYY-MMM') === activeDate
          };

          result.dates.push(new DateObject(dateValue));
        }

        return result;
      }

      function dayModelFactory(milliseconds) {

        var selectedDate = moment.utc(milliseconds);
        var startOfMonth = moment.utc(selectedDate).startOf('month');
        var previousViewDate = moment.utc(selectedDate).startOf('year');
        var endOfMonth = moment.utc(selectedDate).endOf('month');

        var startDate = moment.utc(startOfMonth).subtract(Math.abs(startOfMonth.weekday()), 'days');

        var activeDate = formatValue(ngModelController.$modelValue, 'YYYY-MMM-DD');

        var result = {
          'previousView': 'month',
          'currentView': 'day',
          'nextView': configuration.minView === 'day' ? 'setTime' : 'hour',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: startOfMonth.format('YYYY-MMM')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startOfMonth).subtract(1, 'months').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startOfMonth).add(1, 'months').valueOf()}),
          'dayNames': [],
          'weeks': []
        };


        for (var dayNumber = 0; dayNumber < 7; dayNumber += 1) {
          result.dayNames.push(moment.utc().weekday(dayNumber).format('dd'));
        }

        for (var i = 0; i < 6; i += 1) {
          var week = {dates: []};
          for (var j = 0; j < 7; j += 1) {
            var monthMoment = moment.utc(startDate).add((i * 7) + j, 'days');
            var dateValue = {
              'utcDateValue': monthMoment.valueOf(),
              'display': monthMoment.format('D'),
              'active': monthMoment.format('YYYY-MMM-DD') === activeDate,
              'past': monthMoment.isBefore(startOfMonth),
              'future': monthMoment.isAfter(endOfMonth)
            };
            week.dates.push(new DateObject(dateValue));
          }
          result.weeks.push(week);
        }

        return result;
      }

      function hourModelFactory(milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('day');
        var previousViewDate = moment.utc(selectedDate).startOf('month');

        var activeFormat = formatValue(ngModelController.$modelValue, 'YYYY-MM-DD H');

        var result = {
          'previousView': 'day',
          'currentView': 'hour',
          'nextView': configuration.minView === 'hour' ? 'setTime' : 'minute',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: selectedDate.format('ll')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'days').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'days').valueOf()}),
          'dates': []
        };

        for (var i = 0; i < 24; i += 1) {
          var hourMoment = moment.utc(selectedDate).add(i, 'hours');
          var dateValue = {
            'utcDateValue': hourMoment.valueOf(),
            'display': hourMoment.format('LT'),
            'active': hourMoment.format('YYYY-MM-DD H') === activeFormat
          };

          result.dates.push(new DateObject(dateValue));
        }

        return result;
      }

      function minuteModelFactory(milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('hour');
        var previousViewDate = moment.utc(selectedDate).startOf('day');
        var activeFormat = formatValue(ngModelController.$modelValue, 'YYYY-MM-DD H:mm');

        var result = {
          'previousView': 'hour',
          'currentView': 'minute',
          'nextView': 'setTime',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: selectedDate.format('lll')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'hours').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'hours').valueOf()}),
          'dates': []
        };

        var limit = 60 / configuration.minuteStep;

        for (var i = 0; i < limit; i += 1) {
          var hourMoment = moment.utc(selectedDate).add(i * configuration.minuteStep, 'minute');
          var dateValue = {
            'utcDateValue': hourMoment.valueOf(),
            'display': hourMoment.format('LT'),
            'active': hourMoment.format('YYYY-MM-DD H:mm') === activeFormat
          };

          result.dates.push(new DateObject(dateValue));
        }

        return result;
      }

      function setTime(milliseconds) {
        var tempDate = new Date(milliseconds);
        var newDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds());

        switch (configuration.modelType) {
          case 'Date':
            // No additional work needed
            break;
          case 'moment':
            newDate = moment(newDate);
            break;
          case 'milliseconds':
            newDate = milliseconds;
            break;
          default: // It is assumed that the modelType is a formatting string.
            newDate = moment(newDate).format(configuration.modelType);
        }

        var oldDate = ngModelController.$modelValue;
        ngModelController.$setViewValue(newDate);

        if (configuration.dropdownSelector) {
          jQuery(configuration.dropdownSelector).dropdown('toggle');
        }

        $scope.onSetTime({newDate: newDate, oldDate: oldDate});

        return viewToModelFactory[configuration.startView](milliseconds);
      }

      function $render() {
        $scope.changeView(configuration.startView, new DateObject({utcDateValue: getUTCTime(ngModelController.$viewValue)}));
      }

      function startOfDecade(milliseconds) {
        var startYear = (parseInt(moment.utc(milliseconds).year() / 10, 10) * 10);
        return moment.utc(milliseconds).year(startYear).startOf('year');
      }

      function formatValue(timeValue, formatString) {
        if (timeValue) {
          return getMoment(timeValue).format(formatString);
        } else {
          return '';
        }
      }

      /**
       * Converts a time value into a moment.
       *
       * This function is now necessary because moment logs a warning when parsing a string without a format.
       * @param modelValue
       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
       * @returns {moment}
       *  representing the specified time value.
       */

      function getMoment(modelValue) {
        return moment(modelValue, angular.isString(modelValue) ? configuration.parseFormat : undefined);
      }

      /**
       * Converts a time value to UCT/GMT time.
       * @param modelValue
       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
       * @returns {number}
       *  number of milliseconds since 1/1/1970
       */

      function getUTCTime(modelValue) {
        var tempDate = new Date();
        if (modelValue) {
          var tempMoment = getMoment(modelValue);
          if (tempMoment.isValid()) {
            tempDate = tempMoment.toDate();
          } else {
            throw 'Invalid date: ' + modelValue;
          }
        }
        return tempDate.getTime() - (tempDate.getTimezoneOffset() * 60000);
      }

      function createConfiguration() {
        var directiveConfig = {};

        if ($attrs.datetimepickerConfig) {
          directiveConfig = $scope.$parent.$eval($attrs.datetimepickerConfig);
        }

        var configuration = angular.extend({}, defaultConfig, directiveConfig);

        configurationValidator.validate(configuration);

        return configuration;
      }
    }

    function DateObject() {

      var tempDate = new Date();
      var localOffset = tempDate.getTimezoneOffset() * 60000;

      this.utcDateValue = tempDate.getTime();
      this.selectable = true;


      this.localDateValue = function localDateValue() {
        return this.utcDateValue + localOffset;
      };

      var validProperties = ['utcDateValue', 'localDateValue', 'display', 'active', 'selectable', 'past', 'future'];

      for (var prop in arguments[0]) {
        /* istanbul ignore else */
        //noinspection JSUnfilteredForInLoop
        if (validProperties.indexOf(prop) >= 0) {
          //noinspection JSUnfilteredForInLoop
          this[prop] = arguments[0][prop];
        }
      }
    }

    return directiveDefinition;
  }

  function DateTimePickerConfigProvider() {

    var defaultConfiguration = {
      configureOn: null,
      dropdownSelector: null,
      minuteStep: 5,
      minView: 'minute',
      modelType: 'Date',
      parseFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZZ',
      renderOn: null,
      startView: 'day'
    };

    var defaultLocalization = {
      'bg': {previous: 'предишна', next: 'следваща'},
      'ca': {previous: 'anterior', next: 'següent'},
      'da': {previous: 'forrige', next: 'næste'},
      'de': {previous: 'vorige', next: 'weiter'},
      'en-au': {previous: 'previous', next: 'next'},
      'en-gb': {previous: 'previous', next: 'next'},
      'en': {previous: 'previous', next: 'next'},
      'es-us': {previous: 'atrás', next: 'siguiente'},
      'es': {previous: 'atrás', next: 'siguiente'},
      'fi': {previous: 'edellinen', next: 'seuraava'},
      'fr': {previous: 'précédent', next: 'suivant'},
      'hu': {previous: 'előző', next: 'következő'},
      'it': {previous: 'precedente', next: 'successivo'},
      'ja': {previous: '前へ', next: '次へ'},
      'ml': {previous: 'മുൻപുള്ളത്', next: 'അടുത്തത്'},
      'nl': {previous: 'vorige', next: 'volgende'},
      'pl': {previous: 'poprzednia', next: 'następna'},
      'pt-br': {previous: 'anteriores', next: 'próximos'},
      'pt': {previous: 'anterior', next: 'próximo'},
      'ro': {previous: 'anterior', next: 'următor'},
      'ru': {previous: 'предыдущая', next: 'следующая'},
      'sk': {previous: 'predošlá', next: 'ďalšia'},
      'sv': {previous: 'föregående', next: 'nästa'},
      'tr': {previous: 'önceki', next: 'sonraki'},
      'uk': {previous: 'назад', next: 'далі'},
      'zh-cn': {previous: '上一页', next: '下一页'},
      'zh-tw': {previous: '上一頁', next: '下一頁'}
    };

    var screenReader = defaultLocalization[moment.locale().toLowerCase()];

    return angular.extend({}, defaultConfiguration, {screenReader: screenReader});

  }

  DateTimePickerValidatorService.$inject = ['$log'];

  function DateTimePickerValidatorService($log) {
    return {
      validate: validator
    };
    function validator(configuration) {

      var validOptions = [
        'configureOn',
        'dropdownSelector',
        'minuteStep',
        'minView',
        'modelType',
        'parseFormat',
        'renderOn',
        'startView',
        'screenReader'
      ];

      for (var prop in configuration) {
        //noinspection JSUnfilteredForInLoop
        if (validOptions.indexOf(prop) < 0) {
          throw ('invalid option: ' + prop);
        }
      }

      // Order of the elements in the validViews array is significant.
      var validViews = ['minute', 'hour', 'day', 'month', 'year'];

      if (validViews.indexOf(configuration.startView) < 0) {
        throw ('invalid startView value: ' + configuration.startView);
      }

      if (validViews.indexOf(configuration.minView) < 0) {
        throw ('invalid minView value: ' + configuration.minView);
      }

      if (validViews.indexOf(configuration.minView) > validViews.indexOf(configuration.startView)) {
        throw ('startView must be greater than minView');
      }

      if (!angular.isNumber(configuration.minuteStep)) {
        throw ('minuteStep must be numeric');
      }
      if (configuration.minuteStep <= 0 || configuration.minuteStep >= 60) {
        throw ('minuteStep must be greater than zero and less than 60');
      }
      if (configuration.configureOn !== null && !angular.isString(configuration.configureOn)) {
        throw ('configureOn must be a string');
      }
      if (configuration.configureOn !== null && configuration.configureOn.length < 1) {
        throw ('configureOn must not be an empty string');
      }
      if (configuration.renderOn !== null && !angular.isString(configuration.renderOn)) {
        throw ('renderOn must be a string');
      }
      if (configuration.renderOn !== null && configuration.renderOn.length < 1) {
        throw ('renderOn must not be an empty string');
      }
      if (configuration.modelType !== null && !angular.isString(configuration.modelType)) {
        throw ('modelType must be a string');
      }
      if (configuration.modelType !== null && configuration.modelType.length < 1) {
        throw ('modelType must not be an empty string');
      }
      if (configuration.modelType !== 'Date' && configuration.modelType !== 'moment' && configuration.modelType !== 'milliseconds') {
        // modelType contains string format, overriding parseFormat with modelType
        configuration.parseFormat = configuration.modelType;
      }
      if (configuration.dropdownSelector !== null && !angular.isString(configuration.dropdownSelector)) {
        throw ('dropdownSelector must be a string');
      }

      /* istanbul ignore next */
      if (configuration.dropdownSelector !== null && ((typeof jQuery === 'undefined') || (typeof jQuery().dropdown !== 'function'))) {
        $log.error('Please DO NOT specify the dropdownSelector option unless you are using jQuery AND Bootstrap.js. ' +
          'Please include jQuery AND Bootstrap.js, or write code to close the dropdown in the on-set-time callback. \n\n' +
          'The dropdownSelector configuration option is being removed because it will not function properly.');
        delete configuration.dropdownSelector;
      }
    }
  }
}));
;
/*globals angular */

/**
 * @license angular-bootstrap-datetimepicker  version: 0.4.0
 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
 * License: MIT
 *
 * @author        Dale "Ducky" Lotts
 * @since        2016-Jan-31
 */

(function () {
  'use strict';
  angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function ($templateCache) {
    $templateCache.put('templates/datetimepicker.html', '<div class="datetimepicker table-responsive">\n    <table class="table table-condensed {{ data.currentView }}-view">\n        <thead>\n        <tr>\n            <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="glyphicon glyphicon-arrow-left"><span class="sr-only">{{ screenReader.previous }}</span></i>\n            </th>\n            <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th>\n            <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="glyphicon glyphicon-arrow-right"><span class="sr-only">{{ screenReader.next }}</span></i>\n            </th>\n        </tr>\n        <tr>\n            <th class="dow" data-ng-repeat="day in data.dayNames">{{ day }}</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr data-ng-if="data.currentView !== \'day\'">\n            <td colspan="7">\n                          <span class="{{ data.currentView }}" data-ng-repeat="dateObject in data.dates" data-ng-class="{active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span></td>\n        </tr>\n        <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks">\n            <td data-ng-repeat="dateObject in week.dates" data-ng-click="changeView(data.nextView, dateObject, $event)" class="day" data-ng-class="{active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}">{{ dateObject.display }}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>');
  }]);
}());
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Content', function($stateParams) {
        return {
            _cssForContractors: {
                all: []
            },
            getPathForContractor: function() {
                if (_.contains(['eo', 'giek', 'pgeo', 'pged'], $stateParams.contractor)) {
                    return $stateParams.contractor;
                }

                return 'all';
            },
            getContractorCss: function() {
                return this._cssForContractors[this.getPathForContractor()];
            },
            getCommodity: function(commodity) {
                var commodityName = commodity;
                if (commodityName === 'other') {
                    commodityName = 'others';
                }
                if (_.contains(['energy', 'gas', 'others'], commodityName)) {
                    return commodityName;
                }

                return 'energy';
            },
            getCommodityEnum: function(commodity) {
                var commodityName = commodity;
                if (commodityName === 'others') {
                    commodityName = 'other';
                }
                if (_.contains(['energy', 'gas', 'other'], commodityName)) {
                    return commodityName;
                }

                return 'energy';
            },
            _getControllerPrefix: function(commodity) {
                var commodity = this.getCommodity(commodity);
                var controllerPrefix = commodity.charAt(0).toUpperCase() + commodity.slice(1);
                return controllerPrefix;
            },
            getEventController: function(commodity) {
                return this._getControllerPrefix(commodity) + 'EventController';
            },
            getEventDetailController: function(commodity) {
                return this._getControllerPrefix(commodity) + 'EventDetailController';
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Sessions', function($resource) {
        return $resource(
            'api/account/sessions/:series',
            {},
            {
                getAll: { method: 'GET', isArray: true }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Register', function($resource) {
        return $resource('api/register', {}, {});
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Password', function($resource) {
        return $resource('api/account/change_password', {}, {});
    });

    angular.module('remitEventsApp').factory('PasswordResetInit', function($resource) {
        return $resource('api/account/reset_password/init', {}, {});
    });

    angular.module('remitEventsApp').factory('PasswordResetFinish', function($resource) {
        return $resource('api/account/reset_password/finish', {}, {});
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Activate', function($resource) {
        return $resource(
            'api/activate',
            {},
            {
                get: { method: 'GET', params: {}, isArray: false }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Account', function Account($resource) {
        return $resource(
            'api/account',
            {},
            {
                get: {
                    method: 'GET',
                    params: {},
                    isArray: false,
                    interceptor: {
                        response: function(response) {
                            // expose response
                            return response;
                        }
                    }
                }
            }
        );
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('AuthServerProvider', function loginService($http, localStorageService, $window) {
        return {
            login: function(credentials) {
                var data =
                    'j_username=' +
                    encodeURIComponent(credentials.username) +
                    '&j_password=' +
                    encodeURIComponent(credentials.password) +
                    '&remember-me=' +
                    credentials.rememberMe +
                    '&submit=Login';
                return $http
                    .post('api/authentication', data, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    })
                    .then(function(response) {
                        return response;
                    });
            },
            logout: function() {
                // logout from the server
                $http.post('api/logout').then(function(response) {
                    localStorageService.clearAll();
                    // to get a new csrf token call the api
                    $http.get('api/account');
                    return response;
                });
            },
            getToken: function() {
                var token = localStorageService.get('token');
                return token;
            },
            hasValidToken: function() {
                var token = this.getToken();
                return !!token;
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Principal', function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        return {
            isIdentityResolved: function() {
                return angular.isDefined(_identity);
            },
            isAuthenticated: function() {
                return _authenticated;
            },
            hasAuthority: function(authority) {
                if (!_authenticated) {
                    return $q.when(false);
                }

                return this.identity().then(
                    function(_id) {
                        return _id.authorities && _id.authorities.indexOf(authority) !== -1;
                    },
                    function(err) {
                        return false;
                    }
                );
            },
            hasAnyAuthority: function(authorities) {
                if (!_authenticated || !_identity || !_identity.authorities) {
                    return false;
                }

                for (var i = 0; i < authorities.length; i++) {
                    if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                        return true;
                    }
                }

                return false;
            },
            authenticate: function(identity) {
                _identity = identity;
                _authenticated = identity !== null;
            },
            identity: function(force) {
                var deferred = $q.defer();
                var authenticateEnable = false;

                if (force === true) {
                    _identity = undefined;
                }

                // check and see if we have retrieved the identity data from the server.
                // if we have, reuse it by immediately resolving
                if (angular.isDefined(_identity)) {
                    deferred.resolve(_identity);

                    return deferred.promise;
                }

                // retrieve the identity data from the server, update the identity object, and then resolve.
                if (authenticateEnable) {
                    Account.get()
                        .$promise.then(function(account) {
                            _identity = account.data;
                            _authenticated = true;
                            deferred.resolve(_identity);
                        })
                        .catch(function() {
                            _identity = null;
                            _authenticated = false;
                            deferred.resolve(_identity);
                        });
                } else {
                    _identity = null;
                    _authenticated = false;
                    deferred.resolve(_identity);
                }

                return deferred.promise;
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .factory('Auth', function Auth(
            $rootScope,
            $state,
            $q,
            $translate,
            Principal,
            AuthServerProvider,
            Account,
            Register,
            Activate,
            Password,
            PasswordResetInit,
            PasswordResetFinish
        ) {
            return {
                login: function(credentials, callback) {
                    var cb = callback || angular.noop;
                    var deferred = $q.defer();

                    AuthServerProvider.login(credentials)
                        .then(function(data) {
                            Principal.identity(true).then(function(account) {
                                $translate.use(account.langKey).then(function() {
                                    $translate.refresh();
                                });
                                deferred.resolve(data);
                            });
                            return cb();
                        })
                        .catch(
                            function(err) {
                                this.logout();
                                deferred.reject(err);
                                return cb(err);
                            }.bind(this)
                        );

                    return deferred.promise;
                },

                logout: function() {
                    AuthServerProvider.logout();
                    Principal.authenticate(null);

                    $rootScope.previousStateName = undefined;
                    $rootScope.previousStateNameParams = undefined;
                },

                authorize: function(force) {
                    return Principal.identity(force).then(function() {
                        var isAuthenticated = Principal.isAuthenticated();

                        if (
                            isAuthenticated &&
                            $rootScope.toState.parent === 'account' &&
                            ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')
                        ) {
                            $state.go('main');
                        }

                        if (
                            $rootScope.toState &&
                            $rootScope.toState.data.authorities &&
                            $rootScope.toState.data.authorities.length > 0 &&
                            !Principal.hasAnyAuthority($rootScope.toState.data.authorities)
                        ) {
                            if (isAuthenticated) {
                                $state.go('main');
                            } else {
                                $rootScope.previousStateName = $rootScope.toState;
                                $rootScope.previousStateNameParams = $rootScope.toStateParams;

                                $state.go('main');
                            }
                        }
                    });
                },
                createAccount: function(account, callback) {
                    var cb = callback || angular.noop;

                    return Register.save(
                        account,
                        function() {
                            return cb(account);
                        },
                        function(err) {
                            this.logout();
                            return cb(err);
                        }.bind(this)
                    ).$promise;
                },

                updateAccount: function(account, callback) {
                    var cb = callback || angular.noop;

                    return Account.save(
                        account,
                        function() {
                            return cb(account);
                        },
                        function(err) {
                            return cb(err);
                        }.bind(this)
                    ).$promise;
                },

                activateAccount: function(key, callback) {
                    var cb = callback || angular.noop;

                    return Activate.get(
                        key,
                        function(response) {
                            return cb(response);
                        },
                        function(err) {
                            return cb(err);
                        }.bind(this)
                    ).$promise;
                },

                changePassword: function(newPassword, callback) {
                    var cb = callback || angular.noop;

                    return Password.save(
                        newPassword,
                        function() {
                            return cb();
                        },
                        function(err) {
                            return cb(err);
                        }
                    ).$promise;
                },

                resetPasswordInit: function(mail, callback) {
                    var cb = callback || angular.noop;

                    return PasswordResetInit.save(
                        mail,
                        function() {
                            return cb();
                        },
                        function(err) {
                            return cb(err);
                        }
                    ).$promise;
                },

                resetPasswordFinish: function(keyAndPassword, callback) {
                    var cb = callback || angular.noop;

                    return PasswordResetFinish.save(
                        keyAndPassword,
                        function() {
                            return cb();
                        },
                        function(err) {
                            return cb(err);
                        }
                    ).$promise;
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('AlertService', function($timeout, $sce, $translate) {
        var exports = {
                factory: factory,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning
            },
            alertId = 0, // unique id for each alert. Starts from 0.
            alerts = [],
            timeout = 5000; // default timeout

        function clear() {
            alerts = [];
        }

        function get() {
            return alerts;
        }

        function success(msg, params) {
            this.add({
                type: 'success',
                msg: msg,
                params: params,
                timeout: timeout
            });
        }

        function error(msg, params) {
            this.add({
                type: 'danger',
                msg: msg,
                params: params,
                timeout: timeout
            });
        }

        function warning(msg, params) {
            this.add({
                type: 'warning',
                msg: msg,
                params: params,
                timeout: timeout
            });
        }

        function info(msg, params) {
            this.add({
                type: 'info',
                msg: msg,
                params: params,
                timeout: timeout
            });
        }

        function factory(alertOptions) {
            return alerts.push({
                type: alertOptions.type,
                msg: $sce.trustAsHtml(alertOptions.msg),
                id: alertOptions.alertId,
                timeout: alertOptions.timeout,
                close: function() {
                    return exports.closeAlert(this.id);
                }
            });
        }

        function addAlert(alertOptions) {
            alertOptions.alertId = alertId++;
            alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
            var that = this;
            this.factory(alertOptions);
            if (alertOptions.timeout && alertOptions.timeout > 0) {
                $timeout(function() {
                    that.closeAlert(alertOptions.alertId);
                }, alertOptions.timeout);
            }
        }

        function closeAlert(id) {
            return this.closeAlertByIndex(
                alerts
                    .map(function(e) {
                        return e.id;
                    })
                    .indexOf(id)
            );
        }

        function closeAlertByIndex(index) {
            return alerts.splice(index, 1);
        }

        return exports;
    });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .directive('jhAlert', function(AlertService) {
            return {
                restrict: 'E',
                template:
                    '<div class="alerts" ng-cloak="">' +
                    '<alert ng-cloak="" ng-repeat="alert in alerts" type="{{alert.type}}" close="alert.close()"><pre>{{ alert.msg }}</pre></alert>' +
                    '</div>',
                controller: [
                    '$scope',
                    function($scope) {
                        $scope.alerts = AlertService.get();
                        $scope.$on('$destroy', function() {
                            $scope.alerts = [];
                        });
                    }
                ]
            };
        })
        .directive('jhAlertError', function(AlertService, $rootScope, $translate) {
            return {
                restrict: 'E',
                template:
                    '<div class="alerts" ng-cloak="">' +
                    '<alert ng-cloak="" ng-repeat="alert in alerts" type="{{alert.type}}" close="alert.close()"><pre>{{ alert.msg }}</pre></alert>' +
                    '</div>',
                controller: [
                    '$scope',
                    function($scope) {
                        $scope.alerts = AlertService.get();

                        var addErrorAlert = function(message, key, data) {
                            key = key && key !== null ? key : message;
                            AlertService.error(key, data);
                        };

                        var cleanHttpErrorListener = $rootScope.$on('remitEventsApp.httpError', function(event, httpResponse) {
                            var i;
                            event.stopPropagation();
                            switch (httpResponse.status) {
                                // connection refused, server not reachable
                                case 0:
                                    addErrorAlert('Server not reachable', 'error.serverNotReachable');
                                    break;

                                case 400:
                                    if (httpResponse.data && httpResponse.data.fieldErrors) {
                                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                                            var fieldError = httpResponse.data.fieldErrors[i];
                                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                                            var fieldName = $translate.instant(
                                                'remitEventsApp.' + fieldError.objectName + '.' + convertedField
                                            );
                                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {
                                                fieldName: fieldName
                                            });
                                        }
                                    } else if (httpResponse.data && httpResponse.data.message) {
                                        addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                                    } else {
                                        addErrorAlert(httpResponse.data);
                                    }
                                    break;

                                default:
                                    if (httpResponse.data && httpResponse.data.message) {
                                        addErrorAlert(httpResponse.data.message);
                                    } else {
                                        addErrorAlert(JSON.stringify(httpResponse));
                                    }
                            }
                        });

                        $scope.$on('$destroy', function() {
                            if (cleanHttpErrorListener !== undefined && cleanHttpErrorListener !== null) {
                                cleanHttpErrorListener();
                            }
                        });
                    }
                ]
            };
        });
})();
;
(function() {
  'use strict';

  angular.module('remitEventsApp').config(function($stateProvider) {
      $stateProvider
        .state('main', {
              parent: 'site',
              url: '/',
              params: {
                  lang: 'pl'
              },
              data: {
                  authorities: [],
                  pageTitle: 'remitEventsApp.event.home.title'
              },
              views: {
                  'container@': {
                      templateUrl: 'scripts/app/main/main.html',
                      controller: 'MainController'
                  }
              },
              resolve: {
                  mainTranslatePartialLoader: [
                      '$translate',
                      '$translatePartialLoader',
                      function($translate, $translatePartialLoader) {
                          $translatePartialLoader.addPart('main');
                          return $translate.refresh();
                      }
                  ]
              }
          });
  });
})();
;
(function() {
  'use strict';

  angular.module('remitEventsApp').controller('MainController', function() {});
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'site',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('accessdenied', {
                parent: 'site',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('error');
                            return $translate.refresh();
                        }
                    ]
                }
            });
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').controller('ProductionUnitDialogController', [
        '$scope',
        '$uibModalInstance',
        'entity',
        'ProductionUnit',
        function($scope, $uibModalInstance, entity, ProductionUnit) {
            $scope.productionUnit = entity;
            $scope.load = function(id) {
                ProductionUnit.get({ id: id }, function(result) {
                    $scope.productionUnit = result;
                });
            };

            var onSaveFinished = function(result) {
                $scope.$emit('remitEventsApp:productionUnitUpdate', result);
                $uibModalInstance.close(result);
            };

            $scope.save = function() {
                if ($scope.productionUnit.id != null) {
                    ProductionUnit.update($scope.productionUnit, onSaveFinished);
                } else {
                    ProductionUnit.save($scope.productionUnit, onSaveFinished);
                }
            };

            $scope.clear = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('ProductionUnitDetailController', function($scope, $rootScope, $stateParams, entity, ProductionUnit) {
            $scope.productionUnit = entity;
            $scope.load = function(id) {
                ProductionUnit.get({ id: id }, function(result) {
                    $scope.productionUnit = result;
                });
            };
            var unsubscribe = $rootScope.$on('remitEventsApp:productionUnitUpdate', function(event, result) {
                $scope.productionUnit = result;
            });
            $scope.$on('$destroy', unsubscribe);
        });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($stateProvider) {
        $stateProvider
            .state('productionUnit', {
                parent: 'site',
                url: '/productionUnits',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'remitEventsApp.productionUnit.home.title'
                },
                views: {
                    content: {
                        templateUrl: 'scripts/app/entities/productionUnit/productionUnits.html',
                        controller: 'ProductionUnitController'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('productionUnit');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('productionUnit-detail', {
                parent: 'site',
                url: '/productionUnit/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'remitEventsApp.productionUnit.detail.title'
                },
                views: {
                    content: {
                        templateUrl: 'scripts/app/entities/productionUnit/productionUnit-detail.html',
                        controller: 'ProductionUnitDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('productionUnit');
                            return $translate.refresh();
                        }
                    ],
                    entity: [
                        '$stateParams',
                        'ProductionUnit',
                        function($stateParams, ProductionUnit) {
                            return ProductionUnit.get({ id: $stateParams.id });
                        }
                    ]
                }
            })
            .state('productionUnit-new', {
                parent: 'productionUnit',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: [
                    '$state',
                    '$uibModal',
                    function($state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'scripts/app/entities/productionUnit/productionUnit-dialog.html',
                                controller: 'ProductionUnitDialogController',
                                size: 'lg',
                                resolve: {
                                    entity: function() {
                                        return {
                                            name: null,
                                            shortName: null,
                                            powerplant: null,
                                            marketParticipant: null,
                                            marketParticipantCode: null,
                                            eicCode: null,
                                            regionEicCode: null,
                                            minPower: null,
                                            maxPower: null,
                                            disposablePower: null,
                                            id: null
                                        };
                                    }
                                }
                            })
                            .result.then(
                                function() {
                                    $state.go('productionUnit', null, { reload: true });
                                },
                                function() {
                                    $state.go('productionUnit');
                                }
                            );
                    }
                ]
            })
            .state('productionUnit-edit', {
                parent: 'productionUnit',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'scripts/app/entities/productionUnit/productionUnit-dialog.html',
                                controller: 'ProductionUnitDialogController',
                                size: 'lg',
                                resolve: {
                                    entity: [
                                        'ProductionUnit',
                                        function(ProductionUnit) {
                                            return ProductionUnit.get({ id: $stateParams.id });
                                        }
                                    ]
                                }
                            })
                            .result.then(
                                function() {
                                    $state.go('productionUnit', null, { reload: true });
                                },
                                function() {
                                    $state.go('^');
                                }
                            );
                    }
                ]
            });
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').controller('ProductionUnitController', function($scope, ProductionUnit) {
        $scope.productionUnits = [];
        $scope.loadAll = function() {
            ProductionUnit.query(function(result) {
                $scope.productionUnits = result;
            });
        };
        $scope.loadAll();

        $scope.delete = function(id) {
            ProductionUnit.get({ id: id }, function(result) {
                $scope.productionUnit = result;
                $('#deleteProductionUnitConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function(id) {
            ProductionUnit.delete({ id: id }, function() {
                $scope.loadAll();
                $('#deleteProductionUnitConfirmation').modal('hide');
                $scope.clear();
            });
        };

        $scope.refresh = function() {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function() {
            $scope.productionUnit = {
                name: null,
                shortName: null,
                powerplant: null,
                marketParticipant: null,
                marketParticipantCode: null,
                eicCode: null,
                regionEicCode: null,
                minPower: null,
                maxPower: null,
                disposablePower: null,
                id: null
            };
        };
    });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('OthersEventDetailController', function(
            $state,
            $stateParams,
            $translate,
            $timeout,
            EventDetails,
            EventFilter,
            EventService
        ) {
            var vm = this;

            vm.events = [];
            vm.isIframe = $state.current.data.iframe;

            vm.translateRemarks = function() {
                var currentLang = $translate.use();
                return EventFilter.translateRemarks(vm.events, currentLang);
            };

            vm.translateReasons = function() {
                var currentLang = $translate.use();
                return EventFilter.translateReasons(vm.events, currentLang);
            };

            vm.scrollRightTable = function() {
                EventService.scrollTable(5, '.right-content-table');
            };

            vm.scrollLeftTable = function() {
                EventService.scrollTable(-5, '.right-content-table');
            };

            vm.stopScroll = function() {
                EventService.stopScroll();
            };

            vm.$onInit = function() {
                if ($stateParams.messageId) {
                    EventDetails.query({ messageId: $stateParams.messageId, noPage: 1 }, function(result) {
                        vm.events = result;
                    });
                } else {
                    EventDetails.get({ id: $stateParams.id }, function(result) {
                        vm.events = [result];
                    });
                }

                $timeout(function() {
                    EventService.setTablePosition();
                }, 500);
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('OthersEventController', function(
            $scope,
            $state,
            $stateParams,
            $translate,
            moment,
            Content,
            ContractorFilter,
            EventFilter,
            HelpersService
        ) {
            var vm = this;

            $scope.$on('languageChange', function() {
                vm.updateDateFrom();
                vm.updateDateTo();
            });

            $scope.$watch('event.dateFrom', function(date) {
                vm.dateFromFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$watch('event.dateTo', function(date) {
                vm.dateToFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$on('contractorsSet', function(event, contractors) {
                vm.contractors = contractors;
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    [],
                    vm.dictionaries,
                    $stateParams.contractor
                );
            });

            vm.sort = {
                id: 1
            };
            vm.events = [];
            vm.filters = {};
            vm.eventFilter = {};
            vm.dictionaries = {
                assentNames: []
            };
            vm.isIframe = $state.current.data.iframe;
            vm.config = HelpersService.getPaginationConfig();
            vm.sortOptions = EventFilter.getSortOptions('other');
            vm.contractors = ContractorFilter.getGlobalContractors();

            function getStateName() {
                return $state.current.name + '_' + $stateParams.commodity;
            }

            function initDates() {
                var prevFilters = HelpersService.loadPreviusFilters(getStateName());

                vm.contractors = ContractorFilter.getContractors();

                if (!_.isEmpty(prevFilters)) {
                    vm.dateFrom = prevFilters.dateFrom;
                    vm.dateTo = prevFilters.dateTo;
                    EventFilter.markContractorsSelected(vm.contractors, prevFilters.contractor);
                    EventFilter.markAssentNamesSelected(vm.dictionaries.assentNames, prevFilters.assentNames);
                    vm.eventFilter.contractor = prevFilters.contractor;
                    vm.eventFilter.assentNames = prevFilters.assentNames;
                } else {
                    vm.dateFrom = moment().startOf('day');
                    vm.dateTo = moment().endOf('day');
                    vm.eventFilter.contractor = EventFilter.getSelectedcontractors(vm.contractors, $stateParams.contractor);
                }

                vm.eventFilter = {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    assentNames: EventFilter.getAssentNames(vm.dictionaries.assentNames)
                };
            }

            function loadAll() {
                vm.eventFilter.commodity = $stateParams.commodity.toUpperCase();

                EventFilter.loadAll('other', vm.config, vm.eventFilter, vm.sort, function(result) {
                    vm.events = result.content;
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { totalElements: result.totalElements }));
                });
            }

            vm.setPage = function(page) {
                if (vm.config.page !== page) {
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { page: page }));

                    loadAll();
                }
            };

            vm.searchEvent = function() {
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    [],
                    vm.dictionaries,
                    $stateParams.contractor
                );

                loadAll();
            };

            vm.updateDateFrom = function() {
                var momented = moment(vm.dateFromFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateFrom = momented.startOf('day');
                }
            };

            vm.updateDateTo = function() {
                var momented = moment(vm.dateToFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateTo = momented.endOf('day');
                }
            };

            vm.viewDetails = function(event) {
                var commodity = Content.getCommodity(event.mode.toLowerCase());
                var goState = (vm.isIframe ? 'iframe' : 'event') + '-versions';

                HelpersService.setPreviusFilters(getStateName(), {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor
                });

                $state.go(goState, {
                    messageId: event.messageId.slice(0, -4),
                    contractor: $stateParams.contractor,
                    commodity: commodity
                });
            };

            vm.translateRemarks = function() {
                var currentLang = $translate.use();
                return EventFilter.translateRemarks(vm.events, currentLang);
            };

            vm.excelLink = function() {
                return EventFilter.excelLink(vm.eventFilter);
            };

            vm.$onInit = function() {
                EventFilter.getAssentNamesData()
                    .query()
                    .$promise.then(function(response) {
                        vm.dictionaries.assentNames = _.map(
                            _.filter(response, function(assentName) {
                                return assentName !== null;
                            }),
                            function(assentName) {
                                return { name: assentName };
                            }
                        );
                        initDates();
                        loadAll();
                    });
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('GasEventDetailController', function(
            $state,
            $stateParams,
            $translate,
            $timeout,
            EventDetails,
            EventFilter,
            EventService
        ) {
            var vm = this;

            vm.events = [];
            vm.isIframe = $state.current.data.iframe;

            vm.translateRemarks = function() {
                var currentLang = $translate.use();
                return EventFilter.translateRemarks(vm.events, currentLang);
            };

            vm.translateReasons = function() {
                var currentLang = $translate.use();
                return EventFilter.translateReasons(vm.events, currentLang);
            };

            vm.scrollRightTable = function() {
                EventService.scrollTable(5, '.right-content-table');
            };

            vm.scrollLeftTable = function() {
                EventService.scrollTable(-5, '.right-content-table');
            };

            vm.stopScroll = function() {
                EventService.stopScroll();
            };

            vm.$onInit = function() {
                if ($stateParams.messageId) {
                    EventDetails.query({ messageId: $stateParams.messageId, noPage: 1 }, function(result) {
                        vm.events = result;
                    });
                } else {
                    EventDetails.get({ id: $stateParams.id }, function(result) {
                        vm.events = [result];
                    });
                }

                $timeout(function() {
                    EventService.setTablePosition();
                }, 500);
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('GasEventController', function(
            $rootScope,
            $scope,
            $state,
            $stateParams,
            moment,
            Content,
            ContractorFilter,
            EventFilter,
            HelpersService
        ) {
            var vm = this;

            $scope.$on('languageChange', function() {
                vm.updateDateFrom();
                vm.updateDateTo();
            });

            $scope.$watch('event.dateFrom', function(date) {
                vm.dateFromFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$watch('event.dateTo', function(date) {
                vm.dateToFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$on('contractorsSet', function(event, contractors) {
                vm.contractors = contractors;
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );
            });

            vm.sort = {
                id: 1
            };
            vm.events = [];
            vm.filters = {};
            vm.eventFilter = {};
            vm.dictionaries = {
                assentNames: []
            };
            vm.isIframe = $state.current.data.iframe;
            vm.sortOptions = EventFilter.getSortOptions();
            vm.config = HelpersService.getPaginationConfig();
            vm.contractors = ContractorFilter.getGlobalContractors();

            function getStateName() {
                return $state.current.name + '_' + $stateParams.commodity;
            }

            function initDates() {
                var prevFilters = HelpersService.loadPreviusFilters(getStateName());

                vm.contractors = ContractorFilter.getContractors();
                vm.eventTypes = EventFilter.getEventTypes();

                if (!_.isEmpty(prevFilters)) {
                    vm.dateFrom = prevFilters.dateFrom;
                    vm.dateTo = prevFilters.dateTo;
                    EventFilter.markContractorsSelected(vm.contractors, prevFilters.contractor);
                    EventFilter.markEventTypesSelected(vm.eventTypes, prevFilters.eventTypes);
                    EventFilter.markAssentNamesSelected(vm.dictionaries.assentNames, prevFilters.assentNames);
                    vm.eventFilter.contractor = prevFilters.contractor;
                    vm.eventFilter.eventTypes = prevFilters.eventTypes;
                    vm.eventFilter.assentNames = prevFilters.assentNames;
                } else {
                    vm.dateFrom = moment().startOf('day');
                    vm.dateTo = moment().endOf('day');
                    vm.eventFilter.contractor = EventFilter.getSelectedcontractors(vm.contractors, $stateParams.contractor);
                    vm.eventFilter.eventTypes = [];
                }

                vm.eventFilter = {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes,
                    assentNames: EventFilter.getAssentNames(vm.dictionaries.assentNames)
                };
            }

            function loadAll() {
                EventFilter.loadAll('gas', vm.config, vm.eventFilter, vm.sort, function(result) {
                    vm.events = result.content;
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { totalElements: result.totalElements }));
                });
            }

            vm.setPage = function(page) {
                if (vm.config.page !== page) {
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { page: page }));

                    loadAll();
                }
            };

            vm.searchEvent = function() {
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );

                loadAll();
            };

            vm.updateDateFrom = function() {
                var momented = moment(vm.dateFromFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateFrom = momented.startOf('day');
                }
            };

            vm.updateDateTo = function() {
                var momented = moment(vm.dateToFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateTo = momented.endOf('day');
                }
            };

            vm.viewDetails = function(event) {
                var commodity = Content.getCommodity(event.mode.toLowerCase());
                var goState = (vm.isIframe ? 'iframe' : 'event') + '-versions';

                HelpersService.setPreviusFilters(getStateName(), {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes
                });

                $state.go(goState, {
                    messageId: event.messageId.slice(0, -4),
                    contractor: $stateParams.contractor,
                    commodity: commodity
                });
            };

            vm.excelLink = function() {
                return EventFilter.excelLink(vm.eventFilter);
            };

            vm.$onInit = function() {
                EventFilter.getAssentNamesData()
                    .query()
                    .$promise.then(function(response) {
                        vm.dictionaries.assentNames = _.map(
                            _.filter(response, function(assentName) {
                                return assentName;
                            }),
                            function(assentName) {
                                return { name: assentName };
                            }
                        );
                        initDates();
                        loadAll();
                    });
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('GasConsumptionCapacityController', function(
            $scope,
            $state,
            $stateParams,
            $translate,
            moment,
            Content,
            ContractorFilter,
            EventFilter,
            HelpersService
        ) {
            var vm = this;

            $scope.$on('languageChange', function() {
                vm.updateDateFrom();
                vm.updateDateTo();
            });

            $scope.$watch('capacity.dateTo', function(date) {
                vm.dateToFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$watch('capacity.dateFrom', function(date) {
                vm.dateFromFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            vm.sort = {
                id: 1
            };
            vm.events = [];
            vm.filters = {};
            vm.eventFilter = {};
            vm.dictionaries = {
                assentNames: []
            };
            vm.isIframe = $state.current.data.iframe;
            vm.sortOptions = EventFilter.getSortOptions();
            vm.config = HelpersService.getPaginationConfig();

            function getStateName() {
                return $state.current.name + '_' + $stateParams.commodity;
            }

            function initDates() {
                var prevFilters = HelpersService.loadPreviusFilters(getStateName());

                vm.contractors = ContractorFilter.getContractors();
                vm.eventTypes = EventFilter.getEventTypes();

                if (!_.isEmpty(prevFilters)) {
                    vm.dateFrom = prevFilters.dateFrom;
                    vm.dateTo = prevFilters.dateTo;
                    EventFilter.markContractorsSelected(vm.contractors, prevFilters.contractor);
                    EventFilter.markEventTypesSelected(vm.eventTypes, prevFilters.eventTypes);
                    EventFilter.markAssentNamesSelected(vm.dictionaries.assentNames, prevFilters.assentNames);
                    vm.eventFilter.contractor = prevFilters.contractor;
                    vm.eventFilter.eventTypes = prevFilters.eventTypes;
                    vm.eventFilter.assentNames = prevFilters.assentNames;
                } else {
                    vm.dateFrom = moment().startOf('day');
                    vm.dateTo = moment().endOf('day');
                    vm.eventFilter.contractor = EventFilter.getSelectedcontractors(vm.contractors, $stateParams.contractor);
                    vm.eventFilter.eventTypes = [];
                }

                vm.eventFilter = {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes,
                    assentNames: EventFilter.getAssentNames(vm.dictionaries.assentNames)
                };
            }

            function loadAll() {
                EventFilter.loadAll('gas', vm.config, vm.eventFilter, vm.sort, function(result) {
                    vm.events = result.content;
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { totalElements: result.totalElements }));
                });
            }

            vm.setPage = function(page) {
                if (vm.config.page !== page) {
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { page: page }));

                    loadAll();
                }
            };

            vm.searchEvent = function() {
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );

                loadAll();
            };

            vm.updateDateFrom = function() {
                var momented = moment(vm.dateFromFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateFrom = momented.startOf('day');
                }
            };

            vm.updateDateTo = function() {
                var momented = moment(vm.dateToFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateTo = momented.endOf('day');
                }
            };

            vm.viewDetails = function(event) {
                var commodity = Content.getCommodity(event.mode.toLowerCase());
                var goState = 'event-versions';

                HelpersService.setPreviusFilters(getStateName(), {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor || 'all',
                    eventTypes: vm.eventFilter.eventTypes
                });

                $state.go(goState, {
                    messageId: event.messageId.slice(0, -4),
                    contractor: $stateParams.contractor || 'all',
                    commodity: commodity
                });
            };

            vm.translateRemarks = function() {
                var currentLang = $translate.use();
                return EventFilter.translateRemarks(vm.events, currentLang);
            };

            vm.excelLink = function() {
                return EventFilter.excelLink(vm.eventFilter);
            };

            vm.$onInit = function() {
                EventFilter.getAssentNamesData()
                    .query()
                    .$promise.then(function(response) {
                        vm.dictionaries.assentNames = _.map(
                            _.filter(response, function(assentName) {
                                return assentName !== null;
                            }),
                            function(assentName) {
                                return { name: assentName };
                            }
                        );
                        initDates();
                        loadAll();
                    });
            };
        });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').service('EventService', function(HelpersService) {
        var scrolling;

        this.scrollTable = function(amount, element) {
            var sideGraph = HelpersService.findElement(element ? element : '.side-graph.right');

            scrolling = setInterval(function() {
                var scrollLeft = sideGraph.element.scrollLeft;

                sideGraph.scrollLeft(scrollLeft + amount);
            }, 30);
        };

        this.stopScroll = function() {
            if (scrolling) {
                clearInterval(scrolling);
                scrolling = null;
            }
        };

        this.setTablePosition = function() {
            var widthTable =
                HelpersService.findElement('.table-data-scroll').width() + HelpersService.findElement('.left-content-table').width() + 30;
            var widthContainer = HelpersService.findElement('.events-data').width();
            var $rigthScrollControl = HelpersService.findElement('.scroll-bar.right');
            var $leftScrollControl = HelpersService.findElement('.scroll-bar.left');

            if (widthTable < widthContainer) {
                $rigthScrollControl
                    .css({
                        left:
                            HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').position().left +
                            HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').width() +
                            HelpersService.findElement('.left-content-table').width() +
                            15
                    })
                    .addClass('disabled');
                $leftScrollControl.addClass('disabled');
            } else {
                $rigthScrollControl
                    .removeAttr('style')
                    .css({ right: '14px' })
                    .removeClass('disabled');
                $leftScrollControl.removeClass('disabled');
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($stateProvider) {
        $stateProvider
            .state('event', {
                parent: 'site',
                url: '/events/{commodity}/{contractor}',
                data: {
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.home.title',
                    pageHeader: 'remitEventsApp.event.home.pageTitle'
                },
                params: {
                    contractor: null
                },
                views: {
                    content: {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/events.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventController($stateParams.commodity);
                        },
                        controllerAs: 'event'
                    },
                    graph: {
                        templateUrl: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'scripts/app/entities/event/' + $stateParams.commodity + '/graph.html';
                            }
                            return null;
                        },
                        controllerProvider: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'GraphController';
                            }
                            return null;
                        },
                        controllerAs: 'graph'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            $translatePartialLoader.addPart('graph');

                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('event-others', {
                parent: 'site',
                url: '/events/other/{commodity}/{contractor}',
                params: {
                    contractor: 'all'
                },
                data: {
                    authorities: [],
                    otherEvents: true,
                    pageTitle: 'remitEventsApp.event.home.title',
                    pageHeader: {
                      type: 'check',
                      contractor: 'information',
                      then: 'remitEventsApp.event.home.otherTitle',
                      else: 'remitEventsApp.event.home.pageTitle'
                    }
                },
                views: {
                    content: {
                        templateUrl: 'scripts/app/entities/event/others/events.html',
                        controllerProvider: function(Content) {
                            return Content.getEventController('others');
                        },
                        controllerAs: 'event'
                    },
                    graph: {
                        templateUrl: null,
                        controllerProvider: null
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');

                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('consumption-capacity', {
                parent: 'site',
                url: '/events/{commodity}/consumption/capacity',
                data: {
                    authorities: [],
                    otherEvents: true,
                    pageTitle: 'remitEventsApp.event.home.title',
                    pageHeader: 'remitEventsApp.event.home.consumptionCapacityTitle'
                },
                views: {
                    content: {
                        templateUrl: function($stateParams) {
                            return (
                                'scripts/app/entities/event/' + $stateParams.commodity + '/consumption-capacity/consumption-capacity.html'
                            );
                        },
                        controllerProvider: function($stateParams) {
                            return $stateParams.commodity === 'energy'
                                ? 'EnergyConsumptionCapacityController'
                                : 'GasConsumptionCapacityController';
                        },
                        controllerAs: 'capacity'
                    },
                    graph: {
                        templateUrl: null,
                        controllerProvider: null
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');

                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('iframe', {
                parent: 'site',
                url: '/iframe/{commodity}',
                data: {
                    iframe: true,
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.home.title'
                },
                views: {
                    'tabswrap@': {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/events.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventController($stateParams.commodity);
                        },
                        controllerAs: 'event'
                    },
                    'iframegraph@': {
                        templateUrl: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'scripts/app/entities/event/' + $stateParams.commodity + '/graph.html';
                            }
                            return null;
                        },
                        controllerProvider: function($stateParams) {
                            if ($stateParams.commodity === 'energy') {
                                return 'GraphController';
                            }
                            return null;
                        },
                        controllerAs: 'graph'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            $translatePartialLoader.addPart('graph');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('iframe-other', {
                parent: 'site',
                url: '/iframe/other/{commodity}/{contractor}',
                params: {
                    contractor: 'all'
                },
                data: {
                    iframe: true,
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.home.title'
                },
                views: {
                    'tabswrap@': {
                        templateUrl: 'scripts/app/entities/event/others/events.html',
                        controllerProvider: function(Content) {
                            return Content.getEventController('others');
                        },
                        controllerAs: 'event'
                    },
                    'iframegraph@': {
                        templateUrl: null,
                        controllerProvider: null
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            $translatePartialLoader.addPart('graph');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('event-versions', {
                parent: 'site',
                url: '/{contractor}/event/{commodity}/versions/{messageId}',
                data: {
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.detail.title'
                },
                views: {
                    content: {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/event-detail.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventDetailController($stateParams.commodity);
                        },
                        controllerAs: 'eventDetail'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('iframe-versions', {
                parent: 'site',
                url: '/iframe/{commodity}/versions/{messageId}',
                data: {
                    iframe: true,
                    authorities: [],
                    pageTitle: 'remitEventsApp.event.detail.title'
                },
                views: {
                    'tabswrap@': {
                        templateUrl: function($stateParams) {
                            return 'scripts/app/entities/event/' + $stateParams.commodity + '/event-detail.html';
                        },
                        controllerProvider: function($stateParams, Content) {
                            return Content.getEventDetailController($stateParams.commodity);
                        },
                        controllerAs: 'eventDetail'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('event');
                            $translatePartialLoader.addPart('mriEventType');
                            $translatePartialLoader.addPart('mriUnavailabilityType');
                            $translatePartialLoader.addPart('mriEventStatus');
                            $translatePartialLoader.addPart('mriMode');
                            $translatePartialLoader.addPart('mriFuelType');
                            $translatePartialLoader.addPart('mriMeasureUnit');
                            $translatePartialLoader.addPart('mriCommodity');
                            return $translate.refresh();
                        }
                    ]
                }
            });
    });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('GraphController', function(
            $filter,
            $sce,
            $scope,
            $stateParams,
            $timeout,
            ContractorFilter,
            Graph,
            DictionariesService,
            EventService,
            Unavailability
        ) {
            var vm = this;

            $scope.$watch('graph.graphFilter.day', function(date) {
                vm.dayFormatted = date.format('DD-MM-YYYY');
            });

            $scope.$on('languageChange', function() {
                vm.updateDay();
            });

            $scope.$on('contractorsConfigSet', function(event, contractorsConfig) {
                vm.contractorsConfig = contractorsConfig;
                if ($stateParams.contractor !== 'all') {
                    vm.loadAll();
                }
            });

            vm.tab = 'DAY';
            vm.summary = [];
            vm.timestamps = [];
            vm.powerplants = [];
            vm.selectedGranulation = 'DAY';
            vm.years = DictionariesService.getYears();
            vm.months = DictionariesService.getMonths();
            vm.granulations = DictionariesService.getGranulations();
            vm.contractorsConfig = ContractorFilter.getContractorsConfig();

            vm.graphFilter = {
                week: null,
                day: moment().startOf('day'),
                year: {
                    id: moment().get('year')
                },
                month: {
                    id: moment().get('month')
                }
            };

            vm.isActiveTab = function(granulation) {
                return vm.tab === granulation.id;
            };

            vm.updateWeeks = function() {
                vm.weeks = Graph.getWeeks(vm.graphFilter.year.id);

                var currentWeek = _.find(vm.weeks, function(week) {
                    return week.currentWeek;
                });

                vm.graphFilter.week = currentWeek;
            };

            vm.getPeriodStart = function() {
                if (vm.selectedGranulation === 'DAY') {
                    return moment(vm.graphFilter.day, 'DD/MM/YYYY')
                        .startOf('day')
                        .format('YYYY/MM/DD');
                }
                if (vm.selectedGranulation === 'WEEK') {
                    return vm.graphFilter.week.date.format('YYYY/MM/DD');
                }
                if (vm.selectedGranulation === 'MONTH') {
                    return moment({
                        year: vm.graphFilter.year.id,
                        month: vm.graphFilter.month.id,
                        day: 1
                    }).format('YYYY/MM/DD');
                }
                return moment({
                    year: vm.graphFilter.year.id,
                    month: 0,
                    day: 1
                }).format('YYYY/MM/DD');
            };

            vm.loadAll = function() {
                if ($stateParams.contractor === 'all' || !_.isEmpty(vm.contractorsConfig)) {
                    var queryParams = {
                        mode: 'ENERGY',
                        granulation: vm.selectedGranulation,
                        periodStart: vm.getPeriodStart()
                    };

                    var foundContractor = _.find(vm.contractorsConfig, function(contractor) {
                        return contractor.shortName === $stateParams.contractor;
                    });

                    if (!_.isEmpty(foundContractor)) {
                        queryParams.marketParticipantCode = foundContractor.eicCode;
                    }

                    Unavailability.query(queryParams, function(result) {
                        var powerplants = result.powerplants;
                        Graph.decorateWithStyles(powerplants);
                        Graph.decorateWithVisibility(powerplants);
                        vm.powerplants = powerplants;
                        vm.timestamps = Graph.getDecoratedTimestamps(result.timestamps, vm.selectedGranulation);
                        vm.summary = result.summary;
                    }).$promise.then(function() {
                        $timeout(function() {
                            Graph.setTablePosition();
                        });
                    });
                }
            };

            vm.changeGranulation = function(granulation, $event) {
                $event.preventDefault();
                vm.selectedGranulation = granulation.id;
                vm.tab = granulation.id;
            };

            vm.toggleBlocks = function(groupId) {
                Graph.toggleBlocks(vm.powerplants, groupId);

                $timeout(function() {
                    Graph.setControlsScroll();
                });
            };

            vm.scrollRightTable = function() {
                EventService.scrollTable(5);
            };

            vm.scrollLeftTable = function() {
                EventService.scrollTable(-5);
            };

            vm.stopScroll = function() {
                EventService.stopScroll();
            };

            vm.updateDay = function() {
                var momented = moment(vm.dayFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.graphFilter.day = momented.endOf('day');
                }
            };

            vm.getDataForTooltip = function(tooltips) {
                var tooltip = '';
                var start;
                var stop;
                var block;

                if (!_.isEmpty(tooltips)) {
                    _.each(tooltips, function(el) {
                        block = $filter('translate')('remitEventsApp.graph.tooltip.asset') + ': <b>' + _.escape(el.asset) + '</b> ';
                        start =
                            $filter('translate')('remitEventsApp.graph.tooltip.start') +
                            ': <b>' +
                            moment(el.eventStart).format('DD-MM-YYYY HH:mm') +
                            '</b> ';
                        stop =
                            $filter('translate')('remitEventsApp.graph.tooltip.stop') +
                            ': <b>' +
                            moment(el.eventStop).format('DD-MM-YYYY HH:mm') +
                            '</b>';
                        tooltip +=
                            '<div class="row-tooltip">' +
                            block +
                            $filter('translate')('remitEventsApp.graph.tooltip.unavailable') +
                            ': <b>' +
                            el.unavailability +
                            '</b> ' +
                            $filter('translate')('remitEventsApp.graph.tooltip.available') +
                            ': <b>' +
                            el.availablePower +
                            '</b> ' +
                            start +
                            stop +
                            '</div>';
                    });
                }

                return tooltip;
            };

            vm.$onInit = function() {
                Graph.getLastEventYear()
                    .query()
                    .$promise.then(function(response) {
                        vm.years = _.map(_.range(2011, Math.max(2019, parseInt(response.year)) + 1), function(value) {
                            return {
                                id: value,
                                label: value
                            };
                        });
                    });

                vm.loadAll();
                vm.updateWeeks();
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('EnergyEventDetailController', function(
            $state,
            $stateParams,
            $translate,
            $timeout,
            EventDetails,
            EventFilter,
            EventService
        ) {
            var vm = this;

            vm.events = [];
            vm.isIframe = $state.current.data.iframe;

            vm.translateRemarks = function() {
                var currentLang = $translate.use();
                return EventFilter.translateRemarks(vm.events, currentLang);
            };

            vm.translateReasons = function() {
                var currentLang = $translate.use();
                return EventFilter.translateReasons(vm.events, currentLang);
            };

            vm.scrollRightTable = function() {
                EventService.scrollTable(5, '.right-content-table');
            };

            vm.scrollLeftTable = function() {
                EventService.scrollTable(-5, '.right-content-table');
            };

            vm.stopScroll = function() {
                EventService.stopScroll();
            };

            vm.$onInit = function() {
                if ($stateParams.messageId) {
                    EventDetails.query({ messageId: $stateParams.messageId, noPage: 1 }, function(result) {
                        vm.events = result;
                    });
                } else {
                    EventDetails.query({ id: $stateParams.id, noPage: 1 }, function(result) {
                        vm.events = [result];
                    });
                }

                $timeout(function() {
                    EventService.setTablePosition();
                }, 500);
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('EnergyEventController', function(
            $scope,
            $state,
            $stateParams,
            moment,
            Content,
            ContractorFilter,
            EventFilter,
            HelpersService
        ) {
            var vm = this;

            $scope.$on('languageChange', function() {
                vm.updateDateFrom();
                vm.updateDateTo();
            });

            $scope.$watch('event.dateFrom', function(date) {
                vm.dateFromFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$watch('event.dateTo', function(date) {
                vm.dateToFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$on('contractorsSet', function(event, contractors) {
                vm.contractors = contractors;
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );
            });

            vm.sort = {
                id: 1
            };
            vm.events = [];
            vm.filters = {};
            vm.eventFilter = {};
            vm.dictionaries = {
                assentNames: []
            };
            vm.isIframe = $state.current.data.iframe;
            vm.sortOptions = EventFilter.getSortOptions();
            vm.config = HelpersService.getPaginationConfig();
            vm.contractors = ContractorFilter.getGlobalContractors();

            function getStateName() {
                return $state.current.name + '_' + $stateParams.commodity;
            }

            function initDates() {
                var prevFilters = HelpersService.loadPreviusFilters(getStateName());

                vm.contractors = ContractorFilter.getContractors();
                vm.eventTypes = EventFilter.getEventTypes();

                if (!_.isEmpty(prevFilters)) {
                    vm.dateFrom = prevFilters.dateFrom;
                    vm.dateTo = prevFilters.dateTo;
                    EventFilter.markContractorsSelected(vm.contractors, prevFilters.contractor);
                    EventFilter.markEventTypesSelected(vm.eventTypes, prevFilters.eventTypes);
                    EventFilter.markAssentNamesSelected(vm.dictionaries.assentNames, prevFilters.assentNames);
                    vm.eventFilter.contractor = prevFilters.contractor;
                    vm.eventFilter.eventTypes = prevFilters.eventTypes;
                    vm.eventFilter.assentNames = prevFilters.assentNames;
                } else {
                    vm.dateFrom = moment().startOf('day');
                    vm.dateTo = moment().endOf('day');
                    vm.eventFilter.contractor = EventFilter.getSelectedcontractors(vm.contractors, $stateParams.contractor);
                    vm.eventFilter.eventTypes = [];
                }

                vm.eventFilter = {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes,
                    assentNames: EventFilter.getAssentNames(vm.dictionaries.assentNames)
                };
            }

            function loadAll() {
                EventFilter.loadAll('energy', vm.config, vm.eventFilter, vm.sort, function(result) {
                    vm.events = result.content;
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { totalElements: result.totalElements }));
                });
            }

            vm.setPage = function(page) {
                if (vm.config.page !== page) {
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { page: page }));

                    loadAll();
                }
            };

            vm.searchEvent = function() {
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );

                loadAll();
            };

            vm.updateDateFrom = function() {
                var momented = moment(vm.dateFromFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateFrom = momented.startOf('day');
                }
            };

            vm.updateDateTo = function() {
                var momented = moment(vm.dateToFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateTo = momented.endOf('day');
                }
            };

            vm.viewDetails = function(event) {
                var commodity = Content.getCommodity(event.mode.toLowerCase());
                var goState = (vm.isIframe ? 'iframe' : 'event') + '-versions';

                HelpersService.setPreviusFilters(getStateName(), {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes
                });

                $state.go(goState, {
                    messageId: event.messageId.slice(0, -4),
                    contractor: $stateParams.contractor,
                    commodity: commodity
                });
            };

            vm.excelLink = function() {
                return EventFilter.excelLink(vm.eventFilter);
            };

            vm.$onInit = function() {
                EventFilter.getAssentNamesData()
                    .query()
                    .$promise.then(function(response) {
                        vm.dictionaries.assentNames = _.map(
                            _.filter(response, function(assentName) {
                                return assentName !== null;
                            }),
                            function(assentName) {
                                return { name: assentName };
                            }
                        );
                        initDates();
                        loadAll();
                    });
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('EnergyConsumptionCapacityController', function(
            $scope,
            $state,
            $stateParams,
            $translate,
            moment,
            Content,
            ContractorFilter,
            EventFilter,
            HelpersService
        ) {
            var vm = this;

            $scope.$on('languageChange', function() {
                vm.updateDateFrom();
                vm.updateDateTo();
            });

            $scope.$watch('capacity.dateTo', function(date) {
                vm.dateToFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            $scope.$watch('capacity.dateFrom', function(date) {
                vm.dateFromFormatted = date ? date.format('DD-MM-YYYY') : null;
            });

            vm.sort = {
                id: 1
            };
            vm.events = [];
            vm.filters = {};
            vm.eventFilter = {};
            vm.dictionaries = {
                assentNames: []
            };
            vm.isIframe = $state.current.data.iframe;
            vm.sortOptions = EventFilter.getSortOptions();
            vm.config = HelpersService.getPaginationConfig();

            function getStateName() {
                return $state.current.name + '_' + $stateParams.commodity;
            }

            function initDates() {
                var prevFilters = HelpersService.loadPreviusFilters(getStateName());

                vm.contractors = ContractorFilter.getContractors();
                vm.eventTypes = EventFilter.getEventTypes();

                if (!_.isEmpty(prevFilters)) {
                    vm.dateFrom = prevFilters.dateFrom;
                    vm.dateTo = prevFilters.dateTo;
                    EventFilter.markContractorsSelected(vm.contractors, prevFilters.contractor);
                    EventFilter.markEventTypesSelected(vm.eventTypes, prevFilters.eventTypes);
                    EventFilter.markAssentNamesSelected(vm.dictionaries.assentNames, prevFilters.assentNames);
                    vm.eventFilter.contractor = prevFilters.contractor;
                    vm.eventFilter.eventTypes = prevFilters.eventTypes;
                    vm.eventFilter.assentNames = prevFilters.assentNames;
                } else {
                    vm.dateFrom = moment().startOf('day');
                    vm.dateTo = moment().endOf('day');
                    vm.eventFilter.contractor = EventFilter.getSelectedcontractors(vm.contractors, $stateParams.contractor);
                    vm.eventFilter.eventTypes = [];
                }

                vm.eventFilter = {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor,
                    eventTypes: vm.eventFilter.eventTypes,
                    assentNames: EventFilter.getAssentNames(vm.dictionaries.assentNames)
                };
            }

            function loadAll() {
                vm.eventFilter.unavailabilityType = 'CONSUMPTION_UNAVAILABILITY';
                vm.eventFilter.unavailabilityReason = 'ubytek konsumpcji';

                EventFilter.loadAll('energy', vm.config, vm.eventFilter, vm.sort, function(result) {
                    vm.events = result.content;
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { totalElements: result.totalElements }));
                });
            }

            vm.setPage = function(page) {
                if (vm.config.page !== page) {
                    vm.config = HelpersService.copyObjectArray(_.extend(vm.config, { page: page }));

                    loadAll();
                }
            };

            vm.searchEvent = function() {
                vm.eventFilter = EventFilter.getEventFilter(
                    vm.dateFrom,
                    vm.dateTo,
                    vm.contractors,
                    vm.eventTypes,
                    vm.dictionaries,
                    $stateParams.contractor
                );

                loadAll();
            };

            vm.updateDateFrom = function() {
                var momented = moment(vm.dateFromFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateFrom = momented.startOf('day');
                }
            };

            vm.updateDateTo = function() {
                var momented = moment(vm.dateToFormatted, 'DD-MM-YYYY');
                if (momented.isValid()) {
                    vm.dateTo = momented.endOf('day');
                }
            };

            vm.viewDetails = function(event) {
                var commodity = Content.getCommodity(event.mode.toLowerCase());
                var goState = 'event-versions';

                HelpersService.setPreviusFilters(getStateName(), {
                    dateFrom: vm.dateFrom,
                    dateTo: vm.dateTo,
                    contractor: vm.eventFilter.contractor || 'all',
                    eventTypes: vm.eventFilter.eventTypes
                });

                $state.go(goState, {
                    messageId: event.messageId.slice(0, -4),
                    contractor: $stateParams.contractor || 'all',
                    commodity: commodity
                });
            };

            vm.translateRemarks = function() {
                var currentLang = $translate.use();
                return EventFilter.translateRemarks(vm.events, currentLang);
            };

            vm.excelLink = function() {
                return EventFilter.excelLink(vm.eventFilter);
            };

            vm.$onInit = function() {
                EventFilter.getAssentNamesData()
                    .query()
                    .$promise.then(function(response) {
                        vm.dictionaries.assentNames = _.map(
                            _.filter(response, function(assentName) {
                                return assentName !== null;
                            }),
                            function(assentName) {
                                return { name: assentName };
                            }
                        );
                        initDates();
                        loadAll();
                    });
            };
        });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('notificationInterceptor', function($q, AlertService) {
        return {
            response: function(response) {
                var alertKey = response.headers('X-remitEventsApp-alert');
                if (angular.isString(alertKey)) {
                    AlertService.success(alertKey, { param: response.headers('X-remitEventsApp-params') });
                }
                return response;
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('errorHandlerInterceptor', function($q, $rootScope) {
        return {
            responseError: function(response) {
                if (!(response.status === 401 && response.data.path.indexOf('/api/account') === 0)) {
                    $rootScope.$emit('remitEventsApp.httpError', response);
                }
                return $q.reject(response);
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('authExpiredInterceptor', function($rootScope, $q, $injector) {
        return {
            responseError: function(response) {
                // If we have an unauthorized request we redirect to the login page
                // Don't do this check on the account API to avoid infinite loop
                if (response.status === 401 && response.data.path !== undefined && response.data.path.indexOf('/api/account') === -1) {
                    var Auth = $injector.get('Auth');
                    var $state = $injector.get('$state');
                    var to = $rootScope.toState;
                    var params = $rootScope.toStateParams;
                    Auth.logout();
                    $rootScope.previousStateName = to;
                    $rootScope.previousStateNameParams = params;
                    $state.go('login');
                }
                return $q.reject(response);
            }
        };
    });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .config(function($httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
            httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

            $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
            $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

            $httpProvider.interceptors.push('errorHandlerInterceptor');
            $httpProvider.interceptors.push('authExpiredInterceptor');
            $httpProvider.interceptors.push('notificationInterceptor');

            $urlMatcherFactoryProvider.type('boolean', {
                name: 'boolean',
                decode: function(val) {
                    return val === true || val === 'true';
                },
                encode: function(val) {
                    return val ? 1 : 0;
                },
                equals: function(a, b) {
                    return this.is(a) && a === b;
                },
                is: function(val) {
                    return [true, false, 0, 1].indexOf(val) >= 0;
                },
                pattern: /bool|true|0|1/
            });
        });
})();
;
(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .factory('stateHandler', function stateHandler(
            $rootScope,
            $stateParams,
            $transitions,
            $translate,
            $window,
            Auth,
            HelpersService,
            Language,
            Principal 
        ) {
            function initialize() {
                $transitions.onStart({}, function(trans) {
                    $rootScope.fromState = trans.from();
                    $rootScope.toState = trans.to();
                    $rootScope.toStateParams = trans.params();

                    if (Principal.isIdentityResolved()) {
                        Auth.authorize();
                    }

                    HelpersService.clearPrevData();

                    Language.getCurrent().then(function(language) {
                        $translate.use(language);
                        moment.locale(language);
                    });
                });

                $transitions.onSuccess({}, function(trans) {
                    var toState = trans.to();
                    var fromState = trans.from();
                    var fromParams = $stateParams;
                    var titleKey = 'global.title';

                    if (toState.name !== 'login' && $rootScope.previousStateName) {
                        $rootScope.previousStateName = fromState.name;
                        $rootScope.previousStateParams = fromParams;
                    }

                    if (toState.data.pageTitle) {
                        titleKey = toState.data.pageTitle;
                    }

                    $translate(titleKey).then(function(title) {
                        $window.document.title = title;
                    });
                });
            }

            return {
                initialize: initialize
            };
        });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').factory('translationStorageProvider', function($cookies, LANGUAGES) {
        function get(name) {
            var language = $cookies.get(name);
            language = language ? language.replace(/"/g, '') : 'pl';

            if (LANGUAGES.indexOf($cookies.get(name)) === -1) {
                $cookies.putObject(name, 'pl');
            }
            return language;
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }

        return {
            get: get,
            put: put
        };
    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').run(function($trace, $rootScope, $state, $templateCache, stateHandler, $location, $window, ENV, VERSION) {
        $rootScope.ENV = ENV;
        $rootScope.VERSION = VERSION;

        $trace.disable('TRANSITION');
        $state.defaultErrorHandler(function() {});

        stateHandler.initialize();

        $rootScope.back = function() {
            if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                $state.go('main');
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
            }
        };

        $templateCache.put(
            '/scripts/components/uiblocker/angular-block-ui.ng.html',
            '<div class="block-ui-overlay" style="opacity:1"></div>' +
                '<div class="block-ui-message-container" aria-live="assertive" aria-atomic="true">' +
                '<div class="block-ui-message" ng-class="$_blockUiMessageClass">{{ state.message }}</div>' +
                '</div>'
        );

        $rootScope.$on('$routeChangeSuccess', function(event) {
          gtag('config', 'UA-51902929-20', {'page_path': $location.path()});
        });

    });
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($stateProvider) {
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'menu@': {
                        templateUrl: 'scripts/components/menu/menu.html',
                        controller: 'MenuController',
                        controllerAs: 'menu'
                    },
                    'header@': {
                        templateUrl: 'scripts/components/header/header.html',
                        controller: 'HeaderController',
                        controllerAs: 'header'
                    },
                    'footer@': {
                        templateUrl: 'scripts/components/footer/footer.html',
                        controller: 'FooterController',
                        controllerAs: 'footer'
                    }
                },
                resolve: {
                    authorize: [
                        'Auth',
                        function(Auth) {
                            return Auth.authorize();
                        }
                    ],
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('site', {
                abstract: true,
                parent: 'app',
                views: {
                    'container@': {
                        templateUrl: 'scripts/components/site/site.html',
                        controller: 'SiteController',
                        controllerAs: 'site'
                    }
                }
            });
    });
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('remitEventsApp')
        .constant('VERSION', "1.0-SNAPSHOT")
        .constant('ENV', "prod")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
;
(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($locationProvider, $translateProvider, tmhDynamicLocaleProvider, blockUIConfig) {
        blockUIConfig.delay = 0;
        blockUIConfig.message = 'Loading...';
        blockUIConfig.templateUrl = '/scripts/components/uiblocker/angular-block-ui.ng.html';

        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $locationProvider.hashPrefix('');

        $translateProvider.preferredLanguage('pl');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    });
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('remitEventsApp')
        .constant('VERSION', "1.0-SNAPSHOT")
        .constant('ENV', "dev")
        .constant('DEBUG_INFO_ENABLED', true)
;
})();
;(function(){'use strict';angular.module('remitEventsApp').run(['$templateCache', function($templateCache) {$templateCache.put('scripts/app/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('scripts/app/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{ errorMessage }}</div></div></div></div></div>');
$templateCache.put('scripts/app/main/main.html','<div class="row"><div class="col-xs-12 remit-spa"><h3 translate="main.title"></h3><div class="clearfix"></div><div class="remit-border-bottom"></div></div></div><div class="row"><div class="col-xs-12"><span ng-bind-html="\'main.message\' | translate"></span></div></div>');
$templateCache.put('scripts/components/footer/footer.html','<div class="row"><div class="dark_grey_wrapper"><div id="dark_bottom_menu"><div class="main"><div class="row"><div class="col-lg-9 col-md-9 col-sm-9"><div class="row"><div class="col-lg-1 col-md-4 col-xs-4"><a id="ctl00_A1" ng-href="{{ footer.getLink(\'home\') }}" translate="footer.home"></a></div><div class="col-lg-1 col-md-4 col-xs-4"><a id="ctl00_A4" ng-href="{{ footer.getLink(\'privacyPolicy\') }}"><span translate="footer.privacyPolicy"></span></a></div><div class="col-lg-1 col-md-4 col-xs-4"><a id="ctl00_A6" ng-href="{{ footer.getLink(\'legalReservations\') }}"><span translate="footer.legalReservations"></span></a></div></div></div><div class="col-lg-3 col-md-3 col-sm-3"></div></div><div class="clear"></div></div></div></div><div id="bottom_line"></div></div>');
$templateCache.put('scripts/components/header/header.html','<div class="row-top-line"></div><div class="row margin-bottom"><div class="hidden-lg col-md-12 col-sm-12 col-xs-12"><div class="row background-silver background-mini"><div class="col-md-6 col-sm-6 col-xs-6 menu_box_1"></div><div class="col-md-6 col-sm-6 col-xs-6 menu_box_1"></div></div></div><div class="col-main row"><div class="col-lg-2 col-md-3 col-sm-3 col-xs-3"><div class="row"><div class="col-lg-offset-2"><a href="http://www.orlen.pl/PL/"><img id="logo" alt="Logo Orlen" src="/content/images/logo.png"></a></div></div></div><div class="col-lg-10 col-md-9 col-sm-9 col-xs-9"><div class="f">REMIT</div></div></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="rss_bar"><a ng-click="header.changeLanguage(\'en\')">EN</a> <a ng-click="header.changeLanguage(\'pl\')">PL</a></div></div></div></div></div>');
$templateCache.put('scripts/components/menu/menu.html','<ul class="menu-left-bg"><li><strong><a ui-sref="main">REMIT</a></strong></li><li><a><span translate="menu.energy"></span></a></li><li><a class="margin-left" ui-sref="event({ commodity: \'energy\', contractor: \'all\' })" ng-class="{ \'active\': menu.isActive([\'events/energy/all\', \'events/other/energy/all\']) }"><span translate="menu.production"></span></a></li><li ng-repeat="contractor in menu.contractors"><a class="margin-left-2" ui-sref="event({ commodity: \'energy\', contractor: contractor.shortName })" ng-class="{ \'active\': menu.isActive([\'events/energy/\', \'events/other/energy/\'], contractor.shortName) }"><span ng-bind="contractor.label"></span></a></li><li><a class="margin-left" ui-sref="consumption-capacity({ commodity: \'energy\' })" ui-sref-active="active"><span translate="menu.consumptionCapacity"></span></a></li><li><a class="margin-left" ui-sref="event-others({ commodity: \'energy\', contractor: \'information\' })" ng-class="{ \'active\': menu.isActive(\'other/energy/information\') }"><span translate="menu.other"></span></a></li><li><a class="margin-left" ng-href="{{ menu.getPressOfficeLink(\'energy\') }}"><span translate="menu.energyPress"></span></a></li><li><a><span translate="menu.gas"></span></a></li><li><a class="margin-left" ui-sref="consumption-capacity({ commodity: \'gas\' })" ui-sref-active="active"><span translate="menu.consumptionCapacity"></span></a></li><li><a class="margin-left" ui-sref="event-others({ commodity: \'gas\', contractor: \'information\' })" ng-class="{ \'active\': menu.isActive(\'other/gas/information\') }"><span translate="menu.other"></span></a></li><li><a class="margin-left" ng-href="{{ menu.getPressOfficeLink(\'gas\') }}"><span translate="menu.gasPress"></span></a></li><li><a href="/feed/all"><span>RSS</span></a></li></ul>');
$templateCache.put('scripts/components/pagination/pagination.html','<div id="mri-pagination"><ul id="mri-pagination-list" class="pagination"><li id="go-to-the-first-page" ng-click="pagination.goToPage(1, \'first\')" ng-class="{ \'disabled\': !pagination.isActive( \'first\') }"><i class="fa fa-fast-backward" ng-class="{ \'gray\': !isActive( \'first\') }"></i><p class="element" translate="firstPage"></p></li><li id="go-to-the-previous-page" ng-click="pagination.goToPage(pagination.prevPage, \'prev\')" ng-class="{ \'disabled\': !pagination.isActive( \'prev\') }"><i class="fa fa-step-backward" ng-class="{ \'gray\': !pagination.isActive( \'prev\') }"></i><p class="element" translate="previousPage"></p></li><li ng-repeat="page in pagination.pages track by $index" class="pages"><div id="go-to-the-page-{{page}}" class="page" ng-class="{\'page-active\': (pagination.currentPage === page) }" ng-bind="page" ng-if="page > 0" ng-click="pagination.goToPage(page)"></div><div id="go-to-the-page-{{page}}" class="page" ng-if="page === 0">...</div></li><li id="go-to-the-next-page" ng-click="pagination.goToPage(pagination.nextPage, \'next\')" ng-class="{ \'disabled\': !pagination.isActive(\'next\') }"><p class="element" translate="nextPage"></p><i class="fa fa-step-forward" ng-class="{ \'gray\': !pagination.isActive(\'next\') }"></i></li><li id="go-to-last-page" ng-click="pagination.goToPage(pagination.lastPage, \'last\')" ng-class="{ \'disabled\': !pagination.isActive(\'last\') }"><p class="element" translate="lastPage"></p><i class="fa fa-fast-forward" ng-class="{ \'gray\': !pagination.isActive(\'last\') }"></i></li></ul></div>');
$templateCache.put('scripts/components/site/site.html','<div class="row"><div class="remit-spa"><span class="remit-h3" ng-bind="site.getTitle() | translate">Planowane i nieplanowane ubytki mocy</span><div class="clearfix"></div><div class="remit-border-bottom"></div></div></div><div ui-view="tabs"></div><div class="well" ui-view="content"></div><div ui-view="graph"></div>');
$templateCache.put('scripts/components/tabs/tabs.html','<div class="row"><uib-tabset class="tabs" active="tabs.commodityTabIndex"><uib-tab class="tab" ng-repeat="tab in tabs.tabs" index="$index" heading="{{tab.title | translate}}" ng-click="tabs.go(tab)"></uib-tab></uib-tabset></div>');
$templateCache.put('scripts/components/uiblocker/angular-block-ui.ng.html','<div class="block-ui-overlay" style="opacity:1"></div><div class="block-ui-message-container" aria-live="assertive" aria-atomic="true"><div class="block-ui-message" ng-class="$_blockUiMessageClass">{{ state.message }}</div></div>');
$templateCache.put('scripts/app/entities/productionUnit/productionUnit-detail.html','<div><h2><span translate="remitEventsApp.productionUnit.detail.title">ProductionUnit</span> {{ productionUnit.id }}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="remitEventsApp.productionUnit.name">Name</span></td><td><span class="form-control-static">{{ productionUnit.name }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.shortName">ShortName</span></td><td><span class="form-control-static">{{ productionUnit.shortName }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.powerplant">Powerplant</span></td><td><span class="form-control-static">{{ productionUnit.powerplant }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.marketParticipant">MarketParticipant</span></td><td><span class="form-control-static">{{ productionUnit.marketParticipant }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.marketParticipantCode">MarketParticipantCode</span></td><td><span class="form-control-static">{{ productionUnit.marketParticipantCode }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.eicCode">EicCode</span></td><td><span class="form-control-static">{{ productionUnit.eicCode }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.regionEicCode">RegionEicCode</span></td><td><span class="form-control-static">{{ productionUnit.regionEicCode }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.minPower">MinPower</span></td><td><span class="form-control-static">{{ productionUnit.minPower }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.maxPower">MaxPower</span></td><td><span class="form-control-static">{{ productionUnit.maxPower }}</span></td></tr><tr><td><span translate="remitEventsApp.productionUnit.disposablePower">DisposablePower</span></td><td><span class="form-control-static">{{ productionUnit.disposablePower }}</span></td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/productionUnit/productionUnit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myProductionUnitLabel" translate="remitEventsApp.productionUnit.home.createOrEditLabel">Create or edit a ProductionUnit</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id" translate="global.field.id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="productionUnit.id" readonly="readonly"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="productionUnit.name"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.shortName" for="field_shortName">ShortName</label> <input type="text" class="form-control" name="shortName" id="field_shortName" ng-model="productionUnit.shortName"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.powerplant" for="field_powerplant">Powerplant</label> <input type="text" class="form-control" name="powerplant" id="field_powerplant" ng-model="productionUnit.powerplant"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.marketParticipant" for="field_marketParticipant">MarketParticipant</label> <input type="text" class="form-control" name="marketParticipant" id="field_marketParticipant" ng-model="productionUnit.marketParticipant"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.marketParticipantCode" for="field_marketParticipantCode">MarketParticipantCode</label> <input type="text" class="form-control" name="marketParticipantCode" id="field_marketParticipantCode" ng-model="productionUnit.marketParticipantCode"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.eicCode" for="field_eicCode">EicCode</label> <input type="text" class="form-control" name="eicCode" id="field_eicCode" ng-model="productionUnit.eicCode"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.regionEicCode" for="field_regionEicCode">RegionEicCode</label> <input type="text" class="form-control" name="regionEicCode" id="field_regionEicCode" ng-model="productionUnit.regionEicCode"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.minPower" for="field_minPower">MinPower</label> <input type="number" class="form-control" name="minPower" id="field_minPower" ng-model="productionUnit.minPower"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.maxPower" for="field_maxPower">MaxPower</label> <input type="number" class="form-control" name="maxPower" id="field_maxPower" ng-model="productionUnit.maxPower"></div><div class="form-group"><label translate="remitEventsApp.productionUnit.disposablePower" for="field_disposablePower">DisposablePower</label> <input type="number" class="form-control" name="disposablePower" id="field_disposablePower" ng-model="productionUnit.disposablePower"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || editForm.$submitted" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/productionUnit/productionUnits.html','<div><h2 translate="remitEventsApp.productionUnit.home.title">ProductionUnits</h2><jh-alert></jh-alert><div class="container"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="productionUnit-new"><span class="glyphicon glyphicon-flash"></span> <span translate="remitEventsApp.productionUnit.home.createLabel">Create a new ProductionUnit</span></button></div></div></div><div class="modal fade" id="deleteProductionUnitConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(productionUnit.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="remitEventsApp.productionUnit.delete.question" translate-values="{id: \'{{productionUnit.id}}\'}">Are you sure you want to delete this ProductionUnit?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="remitEventsApp.productionUnit.name">Name</th><th translate="remitEventsApp.productionUnit.shortName">ShortName</th><th translate="remitEventsApp.productionUnit.powerplant">Powerplant</th><th translate="remitEventsApp.productionUnit.marketParticipant">MarketParticipant</th><th translate="remitEventsApp.productionUnit.marketParticipantCode">MarketParticipantCode</th><th translate="remitEventsApp.productionUnit.eicCode">EicCode</th><th translate="remitEventsApp.productionUnit.regionEicCode">RegionEicCode</th><th translate="remitEventsApp.productionUnit.minPower">MinPower</th><th translate="remitEventsApp.productionUnit.maxPower">MaxPower</th><th translate="remitEventsApp.productionUnit.disposablePower">DisposablePower</th><th></th></tr></thead><tbody><tr ng-repeat="productionUnit in productionUnits track by productionUnit.id"><td><a ui-sref="productionUnit-detail({id:productionUnit.id})">{{ productionUnit.id }}</a></td><td>{{ productionUnit.name }}</td><td>{{ productionUnit.shortName }}</td><td>{{ productionUnit.powerplant }}</td><td>{{ productionUnit.marketParticipant }}</td><td>{{ productionUnit.marketParticipantCode }}</td><td>{{ productionUnit.eicCode }}</td><td>{{ productionUnit.regionEicCode }}</td><td>{{ productionUnit.minPower }}</td><td>{{ productionUnit.maxPower }}</td><td>{{ productionUnit.disposablePower }}</td><td><button type="submit" ui-sref="productionUnit-detail({id:productionUnit.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span translate="entity.action.view">View</span></button> <button type="submit" ui-sref="productionUnit-edit({id:productionUnit.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span translate="entity.action.edit">Edit</span></button> <button type="submit" ng-click="delete(productionUnit.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></td></tr></tbody></table></div></div>');
$templateCache.put('scripts/app/entities/event/energy/event-detail.html','<h1 ng-show="eventDetail.isIframe"><span translate="remitEventsApp.event.home.pageTitleAccordanceREMIT">Informacje zgodnie z REMIT</span></h1><div class="row" ng-show="!eventDetail.isIframe"><div class="remit-spa"><h2><span translate="remitEventsApp.event.detail.title">Event</span> {{ event.id }}</h2><a type="submit" onclick="window.history.back()" class="return-link"><i class="glyphicon glyphicon-chevron-left"></i>{{ \'remitEventsApp.event.back\' | translate }}</a><div class="clearfix"></div><div class="remit-border-bottom"></div></div></div><div class="row"><div ng-class="{ \'well\': eventDetail.isIframe }"><div class="events-data"><div class="col-md-3 left-content-table"><table class="table left-table"><thead><tr><th translate="entity.detail.field">Field</th></tr></thead><tbody><tr><td><span translate="remitEventsApp.event.eventStatus">EventStatus</span></td></tr><tr><td><span translate="remitEventsApp.event.unavailabilityType">UnavailabilityType</span></td></tr><tr><td><span translate="remitEventsApp.event.eventType">EventType</span></td></tr><tr><td><span translate="remitEventsApp.event.publicationDateTime">PublicationDateTime</span></td></tr><tr><td><span translate="remitEventsApp.event.eventStart">EventStart</span></td></tr><tr><td><span translate="remitEventsApp.event.eventStop">EventStop</span></td></tr><tr><td><span translate="remitEventsApp.event.unitMeasure">UnitMeasure</span></td></tr><tr><td><span translate="remitEventsApp.event.energy.unavailableCapacity">UnavailableCapacity</span></td></tr><tr><td><span translate="remitEventsApp.event.energy.installedCapacity">InstalledCapacity</span></td></tr><tr><td><span translate="remitEventsApp.event.energy.availableCapacity">AvailableCapacity</span></td></tr><tr><td><span translate="remitEventsApp.event.unavailabilityReason">UnavailabilityReason</span></td></tr><tr><td><span translate="remitEventsApp.event.remarks">Remarks</span></td></tr><tr><td><span translate="remitEventsApp.event.assetsFuelType">AssetsFuelType</span></td></tr><tr><td><span translate="remitEventsApp.event.biddingZone">BiddingZone</span></td></tr><tr><td><span translate="remitEventsApp.event.assetName">AssetName</span></td></tr><tr><td><span translate="remitEventsApp.event.assetsEic">AssetsEic</span></td></tr><tr><td><span translate="remitEventsApp.event.contractor">Contractor</span></td></tr><tr><td><span translate="remitEventsApp.event.marketParticipantCode">MarketParticipantCode</span></td></tr></tbody></table></div><div class="scroll-bar left col-md-3-left" ng-mouseenter="eventDetail.scrollLeftTable()" ng-mouseout="eventDetail.stopScroll()"></div><div class="right-content-table col-md-9"><div class="table-data-scroll"><table class="table right-table"><thead><tr><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static" translate="{{\'remitEventsApp.MriEventStatus.\' + event.eventStatus}}">{{ event.eventStatus }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events"><span class="form-control-static" translate="{{\'remitEventsApp.MriUnavailabilityType.\' + event.unavailabilityType}}" tooltip-placement="top" uib-tooltip="{{\'remitEventsApp.MriUnavailabilityType.\' + event.unavailabilityType | translate}}" tooltip-append-to-body="true">{{ event.unavailabilityType }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static"><span class="sign {{event.eventType}}"></span> {{ \'remitEventsApp.MriEventType.\' + event.eventType | translate }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.publicationDate | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.eventStart | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.eventStop | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static" translate="{{\'remitEventsApp.MriMeasureUnit.\' + event.unitMeasure}}">{{ event.unitMeasure }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.unavailableCapacity }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.installedCapacity }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.availableCapacity }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events | filter: eventDetail.translateReasons"><span class="form-control-static" tooltip-placement="top" uib-tooltip="{{event.unavailabilityReasonTranslated}}" tooltip-append-to-body="true">{{ event.unavailabilityReasonTranslated }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events | filter: eventDetail.translateRemarks"><span class="form-control-static" tooltip-placement="top" uib-tooltip="{{event.remarksTranslated}}" tooltip-append-to-body="true">{{ event.remarksTranslated }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events"><span class="form-control-static" tooltip-placement="top" uib-tooltip="{{\'remitEventsApp.MriFuelType.\' + event.assetsFuelType | translate}}" tooltip-append-to-body="true" translate="{{\'remitEventsApp.MriFuelType.\' + event.assetsFuelType}}">{{ event.assetsFuelType }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.biddingZone }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.assetName }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.assetsEic }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.contractor }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.marketParticipantCode }}</span></td></tr></tbody></table></div></div><div class="scroll-bar right" ng-mouseenter="eventDetail.scrollRightTable()" ng-mouseout="eventDetail.stopScroll()"></div></div><a href="/acer/{{eventDetail.events[0].id}}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div></div>');
$templateCache.put('scripts/app/entities/event/energy/events.html','<h1 ng-show="event.isIframe"><span translate="remitEventsApp.event.home.pageTitleAccordanceREMIT">Informacje zgodnie z REMIT</span></h1><div ng-class="{ \'well\': event.isIframe }"><form><div class="form-group remit-form"><div class="datetime-container"><div class="input-group dropdown"><label for="dateFrom">{{ \'remitEventsApp.event.filter.dateLabel\' | translate }} {{ \'remitEventsApp.event.filter.dateFrom\' | translate }}</label> <input id="dateFrom" type="text" name="dateFrom" data-ng-model="event.dateFromFormatted" ng-blur="event.updateDateFrom()"> <span class="input-group-addon dropdown-dateFrom" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="event.dateFrom" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateFrom\' , minView: \'day\',modelType: \'moment\'}"></datetimepicker></ul></div><div class="input-group dropdown"><label for="dateTo" translate="remitEventsApp.event.filter.dateTo">Date to</label> <input id="dateTo" type="text" name="dateTo" data-ng-model="event.dateToFormatted" ng-blur="event.updateDateTo()"> <span class="input-group-addon dropdown-dateTo" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="event.dateTo" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateTo\' , minView: \'day\', modelType: \'moment\'}"></datetimepicker></ul></div></div><div class="remit-checkbox"><label translate="remitEventsApp.event.filter.eventType" class="checkbox-main">Event Type</label> <label ng-repeat="eventType in event.eventTypes"><input type="checkbox" name="selectedEventTypes[]" value="{{ eventType.value }}" ng-model="eventType.selected"> <span class="checkbox-img"></span><span>{{ eventType.label | translate }}</span></label></div><div class="remit-checkbox"><div class="d-inline-block checkbox-main vertical-top"><label class="checkbox-main assent" translate="remitEventsApp.event.filter.assentName">Assent name</label></div><div class="d-inline-block assent-name"><label ng-repeat="assentName in event.dictionaries.assentNames"><input type="checkbox" name="assentNames[]" value="{{ assentName.name }}" ng-model="assentName.selected"> <span class="checkbox-img"></span><span>{{ assentName.name }}</span></label></div></div><div class="remit-select"><label for="field_sort" class="text-right" translate="remitEventsApp.event.filter.sort">Sort</label> <select class="form-control" name="year" ng-model="event.sort" id="field_sort" ng-options="sort as sort.label | translate for sort in event.sortOptions track by sort.id"></select></div><button type="submit" ng-click="event.searchEvent()" class="btn search margin-left">{{ \'remitEventsApp.event.filter.search\' | translate }}</button></div></form><h2 translate="remitEventsApp.event.home.latestUpdates">The latest updates</h2><div class="table-responsive"><table class="table table-striped bordered-table changed-table"><thead><tr><th translate="remitEventsApp.event.publicationDate">PublicationDate</th><th translate="remitEventsApp.event.publicationTime">PublicationTime</th><th translate="remitEventsApp.event.eventStart">EventStart</th><th translate="remitEventsApp.event.eventStop">EventStop</th><th translate="remitEventsApp.event.contractor">Contractor</th><th translate="remitEventsApp.event.localization">Localization</th><th translate="remitEventsApp.event.assetName">AssetName</th><th translate="remitEventsApp.event.eventType">EventType</th><th translate="remitEventsApp.event.unavailabilityType">UnavailabilityType</th><th translate="remitEventsApp.event.eventStatus">EventStatus</th><th translate="remitEventsApp.event.energy.installedCapacity">InstalledCapacity</th><th translate="remitEventsApp.event.energy.unavailableCapacity">UnavailableCapacity</th><th translate="remitEventsApp.event.energy.availableCapacity">AvailableCapacity</th></tr></thead><tbody><tr ng-repeat="data in event.events | dayspan track by data.id " ng-click="event.viewDetails(data)" ng-class="{ \'notplanned\': data.eventType === \'NOT_PLANNED\' }"><td rowspan="{{ data.sameDayCount }}" ng-show="data.showDate">{{ data.publicationDate | date: \'yyyy-MM-dd\' }}</td><td>{{ data.publicationDate | date: \'HH:mm:ss\' }}</td><td>{{ data.eventStart | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.eventStop | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.contractor }}</td><td>{{ data.localization }}</td><td>{{ data.assetName }}</td><td translate="{{ \'remitEventsApp.MriEventType.\' + data.eventType }}">{{ data.eventType }}</td><td translate="{{ \'remitEventsApp.MriUnavailabilityType.\' + data.unavailabilityType }}">{{ data.unavailabilityType }}</td><td translate="{{ \'remitEventsApp.MriEventStatus.\' + data.eventStatus }}">{{ data.eventStatus }}</td><td>{{ data.installedCapacity }}</td><td>{{ data.unavailableCapacity }}</td><td>{{ data.availableCapacity }}</td></tr></tbody></table></div><mri-pagination config="event.config" set-page="event.setPage(value)"></mri-pagination><a ng-href="{{ event.excelLink() }}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div>');
$templateCache.put('scripts/app/entities/event/energy/graph.html','<div class="well graph"><div><h2 class="additional-margin" translate="remitEventsApp.graph.title">Events</h2><div class="legend"><div class="element"><span class="sign planned"></span> {{ \'remitEventsApp.graph.legend.planned\' | translate }}</div><div class="element"><span class="sign not-planned"></span> {{ \'remitEventsApp.graph.legend.notPlanned\' | translate }}</div></div><jh-alert></jh-alert><div class="graph-container"><ul class="nav nav-tabs tabs-for-energy"><li role="presentation" ng-class="{ \'active\': graph.graphisActiveTab(granulation) }" ng-repeat="granulation in graph.granulations" ng-click="graph.changeGranulation(granulation,$event)"><a href="#">{{ granulation.label | translate }}</a></li></ul></div><form><div class="remit-form additional-margin"><div class="form-group col-input-long" ng-show="graph.selectedGranulation == \'DAY\'"><div class="datetime-container"><label translate="remitEventsApp.graph.granulation.title"></label><div class="input-group dropdown day-drop"><input id="field_day" type="text" name="day" data-ng-model="graph.dayFormatted" ng-blur="graph.updateDay()"> <span class="input-group-addon dropdown-day" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="graph.graphFilter.day" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-day\' , minView: \'day\', modelType: \'moment\'}"></datetimepicker></ul></div></div></div><div class="form-group col-input" ng-show="graph.selectedGranulation !== \'DAY\'"><select class="form-control" name="year" ng-model="graph.graphFilter.year" id="field_year" ng-options="year as year.label for year in graph.years track by year.id" ng-change="graph.updateWeeks()"></select></div><div class="form-group col-input" ng-show="graph.selectedGranulation === \'WEEK\'"><select class="form-control" name="week" ng-model="graph.graphFilter.week" id="field_week" ng-options="week as week.label | translate:week.labelParams for week in graph.weeks track by week.id"></select></div><div class="form-group col-input" ng-show="graph.selectedGranulation === \'MONTH\'"><select class="form-control" name="week" ng-model="graph.graphFilter.month" id="field_month" ng-options="month as month.label | translate for month in graph.months track by month.id"></select></div><button type="submit" ng-click="graph.loadAll()" class="btn search">{{ \'remitEventsApp.event.filter.search\' | translate }}</button></div></form><div class="empty-data" ng-show="!graph.powerplants.length"><h3 class="additional-margin">{{ \'remitEventsApp.graph.emptyData\' | translate }}</h3></div><div class="energy-table table-responsive" ng-show="graph.powerplants.length"><div class="side-graph left col-md-3"><div class="table-with-names"><table class="table table-striped bordered-table"><tbody><tr ng-repeat-start="powerplant in graph.powerplants" ng-show="powerplant.showHeader" class="other-block-headers"><td translate="remitEventsApp.graph.powerplant" class="header-cell">Powerplant</td><td translate="remitEventsApp.graph.asset" class="header-cell">Asset</td><td translate="remitEventsApp.graph.installedCapacity" class="header-cell">Total power [MW]</td></tr><tr class="powerplant-table powerplant-row" style="height: 60px" ng-show="powerplant.visible"><td><div class="first-cell-name"><span class="name-row">{{ powerplant.name }}</span> <a ng-click="graph.toggleBlocks(powerplant.groupId)" class="icon-toggle up-down-img" data-toggle="tooltip" data-placement="down" title="Rozwi\u0144"><i class="glyphicon glyphicon-triangle-bottom"></i></a></div></td><td class="name-powerplant">{{ powerplant.assetCount }}</td><td>{{ powerplant.installedCapacity }}</td></tr><tr class="powerplant-table" ng-repeat="block in powerplant.blocks " style="height: 60px" ng-show="block.visible"><td rowspan="{{ powerplant.blocks.length }}" ng-show="$index === 0"><div class="first-cell-name"><span class="name-row">{{ block.name }}</span> <a ng-click="graph.toggleBlocks(block.groupId)" class="icon-toggle up-down-img" data-toggle="tooltip" data-placement="down" title="Zwi\u0144"><i class="glyphicon glyphicon-triangle-top"></i></a></div></td><td class="name-block" tooltip-placement="top" uib-tooltip="{{ block.blockName }}" tooltip-append-to-body="true">{{ block.blockName }}</td><td>{{ block.installedCapacity }}</td></tr><tr class="summation" ng-hide="powerplant.visible"><td colspan="3" translate="remitEventsApp.graph.summary.installedCapacity">Moc osi\u0105galna</td></tr><tr class="summation" ng-hide="powerplant.visible"><td colspan="3" translate="remitEventsApp.graph.summary.plannedUnavailability">Ubytek planowany</td></tr><tr class="summation" ng-hide="powerplant.visible"><td colspan="3" translate="remitEventsApp.graph.summary.notplannedUnavailability">Ubytek nieplanowany</td></tr><tr class="summation summation-last" ng-hide="powerplant.visible"><td colspan="3" translate="remitEventsApp.graph.summary.availableCapacity">Moc dyspozycyjna</td></tr><tr class="summation hidden-padding-element" ng-repeat-end="" ng-hide="powerplant.visible"><td></td></tr></tbody></table></div><hr><div class="summation-table left"><table class="table bordered-table"><tbody><tr class="summation summation-final"><td colspan="3" translate="remitEventsApp.graph.summary.installedCapacity">Moc osi\u0105galna</td></tr><tr class="summation summation-final"><td colspan="3" translate="remitEventsApp.graph.summary.plannedUnavailability">Ubytek planowany</td></tr><tr class="summation summation-final"><td colspan="3" translate="remitEventsApp.graph.summary.notplannedUnavailability">Ubytek nieplanowany</td></tr><tr class="summation summation-last summation-final"><td colspan="3" translate="remitEventsApp.graph.summary.availableCapacity">Moc dyspozycyjna</td></tr></tbody></table></div></div><div class="scroll-bar left" ng-mouseenter="graph.scrollLeftTable()" ng-mouseout="graph.stopScroll()"></div><div class="side-graph right col-md-9"><div class="table-data-scroll"><div class="table-data"><table class="table table-striped bordered-table container-table"><tbody><tr ng-repeat-start="powerplant in graph.powerplants" ng-show="powerplant.showHeader" class="other-block-headers"><td ng-repeat="timestamp in graph.timestamps" class="header-cell">{{ timestamp.label | translate }}</td></tr><tr class="powerplant-table powerplant-row" style="height: 60px" ng-show="powerplant.visible"><td ng-repeat="unavailability in powerplant.unavailabilities" style="vertical-align: bottom" uib-tooltip-html="graph.getDataForTooltip(unavailability.events)" tooltip-append-to-body="true"><div ng-style="unavailability.notPlannedStyle">&nbsp</div><div ng-style="unavailability.plannedStyle">&nbsp</div></td></tr><tr class="powerplant-table" ng-repeat="block in powerplant.blocks " style="height: 60px" ng-show="block.visible"><td ng-repeat="unavailability in block.unavailabilities" style="vertical-align: bottom" tooltip-placement="top" uib-tooltip-html="graph.getDataForTooltip(unavailability.events)" tooltip-append-to-body="true"><div ng-style="unavailability.notPlannedStyle">&nbsp</div><div ng-style="unavailability.plannedStyle">&nbsp</div></td></tr><tr class="summation" ng-hide="powerplant.visible"><td ng-repeat="unavailability in powerplant.unavailabilities">{{ unavailability.installedCapacity }}</td></tr><tr class="summation" ng-hide="powerplant.visible"><td ng-repeat="unavailability in powerplant.unavailabilities">{{ unavailability.plannedUnavailability }}</td></tr><tr class="summation" ng-hide="powerplant.visible"><td ng-repeat="unavailability in powerplant.unavailabilities">{{ unavailability.notPlannedUnavailability }}</td></tr><tr class="summation summation-last" ng-hide="powerplant.visible"><td ng-repeat="unavailability in powerplant.unavailabilities">{{ unavailability.availableCapacity }}</td></tr><tr class="summation hidden-padding-element" ng-repeat-end="" ng-hide="powerplant.visible"><td></td></tr></tbody></table></div><hr><div class="summation-table right"><table class="table border-table container-table"><tbody><tr class="summation summation-final"><td ng-repeat="unavailability in graph.summary">{{ unavailability.installedCapacity }}</td></tr><tr class="summation summation-final"><td ng-repeat="unavailability in graph.summary">{{ unavailability.plannedUnavailability }}</td></tr><tr class="summation summation-final"><td ng-repeat="unavailability in graph.summary">{{ unavailability.notPlannedUnavailability }}</td></tr><tr class="summation summation-last summation-final"><td ng-repeat="unavailability in graph.summary">{{ unavailability.availableCapacity }}</td></tr></tbody></table></div></div><div class="margin-col"></div></div><div class="scroll-bar right" ng-mouseenter="graph.scrollRightTable()" ng-mouseout="graph.stopScroll()"></div></div></div></div>');
$templateCache.put('scripts/app/entities/event/gas/event-detail.html','<h1 ng-show="eventDetail.isIframe"><span translate="remitEventsApp.event.home.pageTitleAccordanceREMIT">Informacje zgodnie z REMIT</span></h1><div class="row" ng-show="!eventDetail.isIframe"><div class="remit-spa"><h2><span translate="remitEventsApp.event.detail.title">Event</span> {{ event.id }}</h2><a type="submit" onclick="window.history.back()" class="return-link"><i class="glyphicon glyphicon-chevron-left"></i>{{ \'remitEventsApp.event.back\' | translate }}</a><div class="clearfix"></div><div class="remit-border-bottom"></div></div></div><div class="row"><div ng-class="{ \'well\': eventDetail.isIframe }"><div class="events-data"><div class="col-md-3 left-content-table"><table class="table left-table"><thead><tr><th translate="entity.detail.field">Field</th></tr></thead><tbody><tr><td><span translate="remitEventsApp.event.eventStatus">EventStatus</span></td></tr><tr><td><span translate="remitEventsApp.event.unavailabilityType">UnavailabilityType</span></td></tr><tr><td><span translate="remitEventsApp.event.eventType">EventType</span></td></tr><tr><td><span translate="remitEventsApp.event.publicationDateTime">PublicationDateTime</span></td></tr><tr><td><span translate="remitEventsApp.event.eventStart">EventStart</span></td></tr><tr><td><span translate="remitEventsApp.event.eventStop">EventStop</span></td></tr><tr><td><span translate="remitEventsApp.event.unitMeasure">UnitMeasure</span></td></tr><tr><td><span translate="remitEventsApp.event.gas.unavailableCapacity">UnavailableCapacity</span></td></tr><tr><td><span translate="remitEventsApp.event.gas.installedCapacity">InstalledCapacity</span></td></tr><tr><td><span translate="remitEventsApp.event.gas.availableCapacity">AvailableCapacity</span></td></tr><tr><td><span translate="remitEventsApp.event.unavailabilityReason">UnavailabilityReason</span></td></tr><tr><td><span translate="remitEventsApp.event.remarks">Remarks</span></td></tr><tr><td><span translate="remitEventsApp.event.balancingZone">BalancingZone</span></td></tr><tr><td><span translate="remitEventsApp.event.assetName">AssetName</span></td></tr><tr><td><span translate="remitEventsApp.event.contractor">Contractor</span></td></tr><tr><td><span translate="remitEventsApp.event.marketParticipantCode">MarketParticipantCode</span></td></tr></tbody></table></div><div class="scroll-bar left col-md-3-left" ng-mouseenter="eventDetail.scrollLeftTable()" ng-mouseout="eventDetail.stopScroll()"></div><div class="right-content-table col-md-9"><div class="table-data-scroll"><table class="table right-table"><thead><tr><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static" translate="{{ \'remitEventsApp.MriEventStatus.\' + event.eventStatus }}">{{ event.eventStatus }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events"><span class="form-control-static" translate="{{ \'remitEventsApp.MriUnavailabilityType.\' + event.unavailabilityType }}" tooltip-placement="top" uib-tooltip="{{ \'remitEventsApp.MriUnavailabilityType.\' + event.unavailabilityType | translate }}" tooltip-append-to-body="true">{{ event.unavailabilityType }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static"><span class="sign {{ event.eventType }}"></span> {{ \'remitEventsApp.MriEventType.\' + event.eventType | translate }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.publicationDate | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.eventStart | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.eventStop | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static" translate="{{ \'remitEventsApp.MriMeasureUnit.\' + event.unitMeasure }}">{{ event.unitMeasure }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.unavailableCapacity }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.installedCapacity }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.availableCapacity }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events | filter: eventDetail.translateReasons"><span class="form-control-static" tooltip-placement="top" uib-tooltip="{{ event.unavailabilityReasonTranslated }}" tooltip-append-to-body="true">{{ event.unavailabilityReasonTranslated }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events | filter: eventDetail.translateRemarks"><span class="form-control-static" tooltip-placement="top" uib-tooltip="{{ event.remarksTranslated }}" tooltip-append-to-body="true">{{ event.remarksTranslated }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.balancingZone }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.assetName }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.contractor }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.marketParticipantCode }}</span></td></tr></tbody></table></div></div><div class="scroll-bar right" ng-mouseenter="eventDetail.scrollRightTable()" ng-mouseout="eventDetail.stopScroll()"></div></div><a href="/acer/{{ eventDetail.events[0].id }}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div></div>');
$templateCache.put('scripts/app/entities/event/gas/events.html','<h1 ng-show="event.isIframe"><span translate="remitEventsApp.event.home.pageTitleAccordanceREMIT">Informacje zgodnie z REMIT</span></h1><div ng-class="{ \'well\': event.isIframe }"><form><div class="form-group remit-form"><div class="datetime-container"><div class="input-group dropdown"><label for="dateFrom">{{ \'remitEventsApp.event.filter.dateLabel\' | translate }} {{ \'remitEventsApp.event.filter.dateFrom\' | translate }}</label> <input id="dateFrom" type="text" name="dateFrom" data-ng-model="event.dateFromFormatted" ng-blur="event.updateDateFrom()"> <span class="input-group-addon dropdown-dateFrom" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="event.dateFrom" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateFrom\' ,\n                        minView: \'day\', modelType: \'moment\'}"></datetimepicker></ul></div><div class="input-group dropdown"><label for="dateTo" translate="remitEventsApp.event.filter.dateTo">Date to</label> <input id="dateTo" type="text" name="dateTo" data-ng-model="event.dateToFormatted" ng-blur="event.updateDateTo()"> <span class="input-group-addon dropdown-dateTo" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="event.dateTo" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateTo\' ,minView: \'day\', modelType: \'moment\'}"></datetimepicker></ul></div></div><div class="remit-checkbox"><label translate="remitEventsApp.event.filter.eventType" class="checkbox-main">Event Type</label> <label ng-repeat="eventType in event.eventTypes"><input type="checkbox" name="selectedEventTypes[]" value="{{ eventType.value }}" ng-model="eventType.selected"> <span class="checkbox-img"></span><span>{{ eventType.label | translate }}</span></label></div><div class="remit-checkbox"><div class="d-inline-block checkbox-main vertical-top"><label class="checkbox-main assent" translate="remitEventsApp.event.filter.assentName">Assent name</label></div><div class="d-inline-block assent-name"><label ng-repeat="assentName in event.dictionaries.assentNames"><input type="checkbox" name="assentNames[]" value="{{ assentName.name }}" ng-model="assentName.selected"> <span class="checkbox-img"></span><span>{{ assentName.name }}</span></label></div></div><div class="remit-select"><label for="field_sort" class="text-right" translate="remitEventsApp.event.filter.sort">Sort</label> <select class="form-control" name="year" ng-model="event.sort" id="field_sort" ng-options="sort as sort.label | translate for sort in event.sortOptions track by sort.id"></select></div><button type="submit" ng-click="event.searchEvent()" class="btn search margin-left">{{ \'remitEventsApp.event.filter.search\' | translate }}</button></div></form><h2 translate="remitEventsApp.event.home.latestUpdates">The latest updates</h2><div class="table-responsive"><table class="table table-striped bordered-table changed-table"><thead><tr><th translate="remitEventsApp.event.publicationDate">PublicationDate</th><th translate="remitEventsApp.event.publicationTime">PublicationTime</th><th translate="remitEventsApp.event.eventStart">EventStart</th><th translate="remitEventsApp.event.eventStop">EventStop</th><th translate="remitEventsApp.event.contractor">Contractor</th><th translate="remitEventsApp.event.assetName">AssetName</th><th translate="remitEventsApp.event.eventType">EventType</th><th translate="remitEventsApp.event.unavailabilityType">UnavailabilityType</th><th translate="remitEventsApp.event.eventStatus">EventStatus</th><th translate="remitEventsApp.event.gas.installedCapacity">InstalledCapacity</th><th translate="remitEventsApp.event.gas.unavailableCapacity">UnavailableCapacity</th><th translate="remitEventsApp.event.gas.availableCapacity">AvailableCapacity</th></tr></thead><tbody><tr ng-repeat="data in event.events | dayspan track by data.id" ng-click="event.viewDetails(data)" ng-class="{ \'notplanned\': data.eventType === \'NOT_PLANNED\' }"><td rowspan="{{ data.sameDayCount }}" ng-show="data.showDate">{{ data.publicationDate | date: \'yyyy-MM-dd\' }}</td><td>{{ data.publicationDate | date: \'HH:mm:ss\' }}</td><td>{{ data.eventStart | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.eventStop | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.contractor }}</td><td>{{ data.assetName }}</td><td translate="{{ \'remitEventsApp.MriEventType.\' + data.eventType }}">{{ data.eventType }}</td><td translate="{{ \'remitEventsApp.MriUnavailabilityType.\' + data.unavailabilityType }}">{{ data.unavailabilityType }}</td><td translate="{{ \'remitEventsApp.MriEventStatus.\' + data.eventStatus }}">{{ data.eventStatus }}</td><td>{{ data.installedCapacity }}</td><td>{{ data.unavailableCapacity }}</td><td>{{ data.availableCapacity }}</td></tr></tbody></table></div><mri-pagination config="event.config" set-page="event.setPage(value)"></mri-pagination><a ng-href="{{ event.excelLink() }}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div>');
$templateCache.put('scripts/app/entities/event/others/event-detail.html','<h1 ng-show="eventDetail.isIframe"><span translate="remitEventsApp.event.home.pageTitleAccordanceREMIT">Informacje zgodnie z REMIT</span></h1><div class="row" ng-show="!eventDetail.isIframe"><div class="remit-spa"><h2><span translate="remitEventsApp.event.detail.title">Event</span> {{ event.id }}</h2><a type="submit" onclick="window.history.back()" class="return-link"><i class="glyphicon glyphicon-chevron-left"></i>{{ \'remitEventsApp.event.back\' | translate }}</a><div class="clearfix"></div><div class="remit-border-bottom"></div></div></div><div class="row"><div ng-class="{ \'well\': eventDetail.isIframe }"><div class="events-data"><div class="col-md-3 left-content-table"><table class="table left-table"><thead><tr><th translate="entity.detail.field">Field</th></tr></thead><tbody><tr><td><span translate="remitEventsApp.event.eventStatus">EventStatus</span></td></tr><tr><td><span translate="remitEventsApp.event.publicationDateTime">PublicationDateTime</span></td></tr><tr><td><span translate="remitEventsApp.event.eventStart">EventStart</span></td></tr><tr><td><span translate="remitEventsApp.event.eventStop">EventStop</span></td></tr><tr><td><span translate="remitEventsApp.event.remarks">Remarks</span></td></tr><tr><td><span translate="remitEventsApp.event.contractor">Contractor</span></td></tr><tr><td><span translate="remitEventsApp.event.marketParticipantCode">MarketParticipantCode</span></td></tr></tbody></table></div><div class="scroll-bar left col-md-3-left" ng-mouseenter="eventDetail.scrollLeftTable()" ng-mouseout="eventDetail.stopScroll()"></div><div class="right-content-table col-md-9"><div class="table-data-scroll"><table class="table right-table"><thead><tr><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static" translate="{{\'remitEventsApp.MriEventStatus.\' + event.eventStatus}}">{{ event.eventStatus }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.publicationDate | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.eventStart | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.eventStop | date: \'yyyy-MM-dd HH:mm:ss\' }}</span></td></tr><tr><td class="ellipsis" ng-repeat="event in eventDetail.events | filter: eventDetail.translateRemarks"><span class="form-control-static" tooltip-placement="top" uib-tooltip="{{event.remarksTranslated}}" tooltip-append-to-body="true">{{ event.remarksTranslated }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.contractor }}</span></td></tr><tr><td ng-repeat="event in eventDetail.events"><span class="form-control-static">{{ event.marketParticipantCode }}</span></td></tr></tbody></table></div></div><div class="scroll-bar right" ng-mouseenter="eventDetail.scrollRightTable()" ng-mouseout="eventDetail.stopScroll()"></div></div><a href="/acer/{{eventDetail.events[0].id}}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div></div>');
$templateCache.put('scripts/app/entities/event/others/events.html','<h1 ng-show="event.isIframe"><span translate="remitEventsApp.event.home.pageTitleAccordanceREMIT">Informacje zgodnie z REMIT</span></h1><div ng-class="{ \'well\': event.isIframe }"><form><div class="form-group remit-form"><div class="datetime-container"><div class="input-group dropdown"><label for="dateFrom">{{ \'remitEventsApp.event.filter.otherDateLabel\' | translate }} {{ \'remitEventsApp.event.filter.dateFrom\' | translate }}</label> <input id="dateFrom" type="text" name="dateFrom" data-ng-model="event.dateFromFormatted" ng-blur="event.updateDateFrom()"> <span class="input-group-addon dropdown-dateFrom" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="event.dateFrom" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateFrom\' , minView: \'day\', modelType: \'moment\'}"></datetimepicker></ul></div><div class="input-group dropdown"><label for="dateTo" translate="remitEventsApp.event.filter.dateTo">Date to</label> <input id="dateTo" type="text" name="dateTo" data-ng-model="event.dateToFormatted" ng-blur="event.updateDateTo()"> <span class="input-group-addon dropdown-dateTo" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="event.dateTo" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateTo\' , minView: \'day\',modelType: \'moment\'}"></datetimepicker></ul></div></div><div class="remit-select"><label for="field_sort" class="text-right" translate="remitEventsApp.event.filter.sort">Sort</label> <select class="form-control" name="year" ng-model="event.sort" id="field_sort" ng-options="sort as sort.label | translate for sort in event.sortOptions track by sort.id"></select></div><button type="submit" ng-click="event.searchEvent()" class="btn search margin-left">{{ \'remitEventsApp.event.filter.search\' | translate }}</button></div></form><h2 translate="remitEventsApp.event.home.latestUpdates">The latest updates</h2><div class="table-responsive"><table class="table table-striped bordered-table changed-table"><thead><tr><th translate="remitEventsApp.event.publicationDate">PublicationDate</th><th translate="remitEventsApp.event.publicationTime">PublicationTime</th><th translate="remitEventsApp.event.contractor">Contractor</th><th translate="remitEventsApp.event.remarks">Remarks</th><th translate="remitEventsApp.event.eventStatus">EventStatus</th></tr></thead><tbody><tr ng-repeat="data in event.events | filter: event.translateRemarks | dayspan track by data.id " ng-click="event.viewDetails(data)" ng-class="{ \'notplanned\': data.eventType === \'NOT_PLANNED\' }"><td rowspan="{{ data.sameDayCount }}" ng-show="data.showDate">{{ data.publicationDate | date: \'yyyy-MM-dd\' }}</td><td>{{ data.publicationDate | date: \'HH:mm:ss\' }}</td><td>{{ data.contractor }}</td><td>{{ data.remarksTranslated }}</td><td translate="{{ \'remitEventsApp.MriEventStatus.\' + data.eventStatus }}">{{ data.eventStatus }}</td></tr></tbody></table><mri-pagination config="event.config" set-page="event.setPage(value)"></mri-pagination></div><a ng-href="{{ event.excelLink() }}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div>');
$templateCache.put('scripts/app/entities/event/energy/consumption-capacity/consumption-capacity.html','<div><form><div class="form-group remit-form"><div class="datetime-container"><div class="input-group dropdown"><label for="dateFrom">{{ \'remitEventsApp.event.filter.dateLabel\' | translate }} {{ \'remitEventsApp.event.filter.dateFrom\' | translate }}</label> <input id="dateFrom" type="text" name="dateFrom" data-ng-model="capacity.dateFromFormatted" ng-blur="capacity.updateDateFrom()"> <span class="input-group-addon dropdown-dateFrom" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="capacity.dateFrom" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateFrom\' , minView: \'day\', modelType: \'moment\'}"></datetimepicker></ul></div><div class="input-group dropdown"><label for="dateTo" translate="remitEventsApp.event.filter.dateTo">Date to</label> <input id="dateTo" type="text" name="dateTo" data-ng-model="capacity.dateToFormatted" ng-blur="capacity.updateDateTo()"> <span class="input-group-addon dropdown-dateTo" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="capacity.dateTo" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateTo\' , minView: \'day\',modelType: \'moment\'}"></datetimepicker></ul></div></div><div class="remit-checkbox"><label translate="remitEventsApp.event.filter.eventType" class="checkbox-main">Event Type</label> <label ng-repeat="eventType in capacity.eventTypes"><input type="checkbox" name="selectedEventTypes[]" value="{{ eventType.value }}" ng-model="eventType.selected"> <span class="checkbox-img"></span><span>{{ eventType.label | translate }}</span></label></div><div class="remit-checkbox"><div class="d-inline-block checkbox-main vertical-top"><label class="checkbox-main assent" translate="remitEventsApp.event.filter.assentName">Assent name</label></div><div class="d-inline-block assent-name"><label ng-repeat="assentName in capacity.dictionaries.assentNames"><input type="checkbox" name="assentNames[]" value="{{ assentName.name }}" ng-model="assentName.selected"> <span class="checkbox-img"></span><span>{{ assentName.name }}</span></label></div></div><div class="remit-select"><label for="field_sort" class="text-right" translate="remitEventsApp.event.filter.sort">Sort</label> <select class="form-control" name="year" ng-model="capacity.sort" id="field_sort" ng-options="sort as sort.label | translate for sort in capacity.sortOptions track by sort.id"></select></div><button type="submit" ng-click="capacity.searchEvent()" class="btn search margin-left">{{ \'remitEventsApp.event.filter.search\' | translate }}</button></div></form><h2 translate="remitEventsApp.event.home.latestUpdates">The latest updates</h2><div class="table-responsive"><table class="table table-striped bordered-table changed-table"><thead><tr><th translate="remitEventsApp.event.publicationDate">PublicationDate</th><th translate="remitEventsApp.event.publicationTime">PublicationTime</th><th translate="remitEventsApp.event.contractor">Contractor</th><th translate="remitEventsApp.event.eventStart">EventStart</th><th translate="remitEventsApp.event.eventStop">EventStop</th><th translate="remitEventsApp.event.remarks">Remarks</th><th translate="remitEventsApp.event.eventStatus">EventStatus</th><th translate="remitEventsApp.event.energy.installedCapacity">InstalledCapacity</th><th translate="remitEventsApp.event.energy.unavailableCapacity">UnavailableCapacity</th><th translate="remitEventsApp.event.energy.availableCapacity">AvailableCapacity</th></tr></thead><tbody><tr ng-repeat="data in capacity.events | filter: capacity.translateRemarks | dayspan track by data.id " ng-click="capacity.viewDetails(data)" ng-class="{ \'notplanned\': data.eventType === \'NOT_PLANNED\' }"><td rowspan="{{ data.sameDayCount }}" ng-show="data.showDate">{{ data.publicationDate | date: \'yyyy-MM-dd\' }}</td><td>{{ data.publicationDate | date: \'HH:mm:ss\' }}</td><td>{{ data.contractor }}</td><td>{{ data.eventStart | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.eventStop | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.remarksTranslated }}</td><td translate="{{ \'remitEventsApp.MriEventStatus.\' + data.eventStatus }}">{{ data.eventStatus }}</td><td>{{ data.installedCapacity }}</td><td>{{ data.unavailableCapacity }}</td><td>{{ data.availableCapacity }}</td></tr></tbody></table></div><mri-pagination config="capacity.config" set-page="capacity.setPage(value)"></mri-pagination><a ng-href="{{ capacity.excelLink() }}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div>');
$templateCache.put('scripts/app/entities/event/gas/consumption-capacity/consumption-capacity.html','<div><form><div class="form-group remit-form"><div class="datetime-container"><div class="input-group dropdown"><label for="dateFrom">{{ \'remitEventsApp.event.filter.dateLabel\' | translate }} {{ \'remitEventsApp.event.filter.dateFrom\' | translate }}</label> <input id="dateFrom" type="text" name="dateFrom" data-ng-model="capacity.dateFromFormatted" ng-blur="capacity.updateDateFrom()"> <span class="input-group-addon dropdown-dateFrom" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="capacity.dateFrom" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateFrom\' , minView: \'day\', modelType: \'moment\'}"></datetimepicker></ul></div><div class="input-group dropdown"><label for="dateTo" translate="remitEventsApp.event.filter.dateTo">Date to</label> <input id="dateTo" type="text" name="dateTo" data-ng-model="capacity.dateToFormatted" ng-blur="capacity.updateDateTo()"> <span class="input-group-addon dropdown-dateTo" data-toggle="dropdown"><i class="ui-datepicker-trigger"></i></span><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="capacity.dateTo" data-datetimepicker-config="{ dropdownSelector: \'.dropdown-dateTo\' , minView: \'day\',modelType: \'moment\'}"></datetimepicker></ul></div></div><div class="remit-checkbox"><label translate="remitEventsApp.event.filter.eventType" class="checkbox-main">Event Type</label> <label ng-repeat="eventType in capacity.eventTypes"><input type="checkbox" name="selectedEventTypes[]" value="{{ eventType.value }}" ng-model="eventType.selected"> <span class="checkbox-img"></span><span>{{ eventType.label | translate }}</span></label></div><div class="remit-checkbox"><div class="d-inline-block checkbox-main vertical-top"><label class="checkbox-main assent" translate="remitEventsApp.event.filter.assentName">Assent name</label></div><div class="d-inline-block assent-name"><label ng-repeat="assentName in capacity.dictionaries.assentNames"><input type="checkbox" name="assentNames[]" value="{{ assentName.name }}" ng-model="assentName.selected"> <span class="checkbox-img"></span><span>{{ assentName.name }}</span></label></div></div><div class="remit-select"><label for="field_sort" class="text-right" translate="remitEventsApp.event.filter.sort">Sort</label> <select class="form-control" name="year" ng-model="capacity.sort" id="field_sort" ng-options="sort as sort.label | translate for sort in capacity.sortOptions track by sort.id"></select></div><button type="submit" ng-click="capacity.searchEvent()" class="btn search margin-left">{{ \'remitEventsApp.event.filter.search\' | translate }}</button></div></form><h2 translate="remitEventsApp.event.home.latestUpdates">The latest updates</h2><div class="table-responsive"><table class="table table-striped bordered-table changed-table"><thead><tr><th translate="remitEventsApp.event.publicationDate">PublicationDate</th><th translate="remitEventsApp.event.publicationTime">PublicationTime</th><th translate="remitEventsApp.event.eventStart">EventStart</th><th translate="remitEventsApp.event.eventStop">EventStop</th><th translate="remitEventsApp.event.contractor">Contractor</th><th translate="remitEventsApp.event.assetName">AssetName</th><th translate="remitEventsApp.event.eventType">EventType</th><th translate="remitEventsApp.event.unavailabilityType">UnavailabilityType</th><th translate="remitEventsApp.event.eventStatus">EventStatus</th><th translate="remitEventsApp.event.gas.installedCapacity">InstalledCapacity</th><th translate="remitEventsApp.event.gas.unavailableCapacity">UnavailableCapacity</th><th translate="remitEventsApp.event.gas.availableCapacity">AvailableCapacity</th></tr></thead><tbody><tr ng-repeat="data in capacity.events | filter: capacity.translateRemarks | dayspan track by data.id " ng-click="capacity.viewDetails(data)" ng-class="{ \'notplanned\': data.eventType === \'NOT_PLANNED\' }"><td rowspan="{{ data.sameDayCount }}" ng-show="data.showDate">{{ data.publicationDate | date: \'yyyy-MM-dd\' }}</td><td>{{ data.publicationDate | date: \'HH:mm:ss\' }}</td><td>{{ data.eventStart | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.eventStop | date: \'yyyy-MM-dd HH:mm:ss\' }}</td><td>{{ data.contractor }}</td><td>{{ data.assetName }}</td><td translate="{{ \'remitEventsApp.MriEventType.\' + data.eventType }}">{{ data.eventType }}</td><td translate="{{ \'remitEventsApp.MriUnavailabilityType.\' + data.unavailabilityType }}">{{ data.unavailabilityType }}</td><td translate="{{ \'remitEventsApp.MriEventStatus.\' + data.eventStatus }}">{{ data.eventStatus }}</td><td>{{ data.installedCapacity }}</td><td>{{ data.unavailableCapacity }}</td><td>{{ data.availableCapacity }}</td></tr></tbody></table></div><mri-pagination config="capacity.config" set-page="capacity.setPage(value)"></mri-pagination><a ng-href="{{ capacity.excelLink() }}" class="btn-save"><i class="glyphicon glyphicon-floppy-save"></i></a></div>');}]);})();